<div class="max-w-[90vw] min-w-[60vw]">
    <!-- Header -->
    <div
        class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary"
        style="margin: -24px"
    >
        <div class="text-lg font-medium">Create New Quote</div>
        <div class="flex items-center gap-2">
            <!-- Revision picker: only meaningful once a quote has more than one
                 revision in its group. Lists original + a, b, ... and opens the
                 chosen one (the kanban itself only ever shows the latest). -->
            @if (revisions.length > 1) {
            <button
                mat-flat-button
                class="!bg-white !text-primary font-semibold rounded-full shadow-sm hover:!bg-gray-100"
                [matMenuTriggerFor]="revisionsMenu"
                type="button"
            >
                <mat-icon
                    class="icon-size-5 mr-1 !text-primary"
                    [svgIcon]="'heroicons_outline:document-duplicate'"
                ></mat-icon>
                Revisions ({{ revisions.length }})
            </button>
            <mat-menu #revisionsMenu="matMenu">
                @for (rev of revisions; track rev.dealId) {
                <button
                    mat-menu-item
                    [disabled]="rev.dealId === dealId"
                    (click)="openRevision(rev)"
                >
                    <span class="font-medium">{{ rev.quoteRef }}</span>
                    @if (rev.dealId === dealId) {
                    <span class="ml-2 text-xs text-primary">(current)</span>
                    } @else if (rev.isLatestRevision) {
                    <span class="ml-2 text-xs text-secondary">(latest)</span>
                    }
                    <span class="ml-2 text-xs text-secondary">
                        {{ rev.createdUTC | date: "dd MMM yyyy" }} ·
                        {{ rev.value | currency: "GBP" }}
                    </span>
                </button>
                }
            </mat-menu>
            }
            <button mat-icon-button (click)="close()" [tabIndex]="-1">
                <mat-icon
                    class="text-current"
                    [svgIcon]="'heroicons_outline:x-mark'"
                ></mat-icon>
            </button>
        </div>
    </div>

    <div class="mt-12 max-h-[calc(100vh-170px)] overflow-y-scroll px-1">
        <mat-horizontal-stepper
            [linear]="isLinear"
            labelPosition="bottom"
            #stepper
            [selectedIndex]="selectedStepIndex"
            (selectionChange)="onStepChange($event)"
            [class.block-review-header]="
                !productsForm?.valid ||
                (isLinear && isCustomQuote() && !deal?.isSentToSales)
            "
            [class.block-preview-header]="!summaryForm?.valid"
        >
            <!-- Customer Details -->
            <mat-step label="Customer Details" [stepControl]="customerForm">
                @if (customerForm) {
                <form [formGroup]="customerForm" class="mt-4">
                    <div class="w-full flex flex-col gap-4">
                        <!-- Order Type -->
                        <!-- <div class="border rounded-2xl p-5 flex flex-col gap-4 w-full bg-[#f8f8f8]">
              <div class="grid grid-cols-3 gap-4">
                <mat-label class="col-span-3 text-xl mt-4">Manufacture Process</mat-label>
                <mat-form-field class="w-full fuse-mat-dense" subscriptSizing="dynamic">
                  <mat-label>Category</mat-label>
                  <mat-select [value]="selectedManufactureCategoryId" (selectionChange)="manufactureCategoryChanged($event)">
                    <ng-container *ngFor="let cat of manufactureProcesses">
                      <mat-option [value]="cat.manufactureProcessCategoryId">
                        {{ cat.name }}
                      </mat-option>
                    </ng-container>
                  </mat-select>
                </mat-form-field>
                <mat-form-field class="w-full fuse-mat-dense" subscriptSizing="dynamic">
                  <mat-label>Process</mat-label>
                  <mat-select [value]="selectedManufactureProcessId" (selectionChange)="manufactureProcessChanged($event)">
                    <ng-container *ngFor="let process of getManufactureProcesses(); trackBy: trackByFn">
                      <mat-option [value]="process.manufactureProcessId">
                        {{ process.name }}
                      </mat-option>
                    </ng-container>
                  </mat-select>
                </mat-form-field>
                <mat-form-field class="w-full fuse-mat-dense" subscriptSizing="dynamic">
                  <mat-label>Product Type</mat-label>
                  <mat-select [formControlName]="'manufactureColumnDefinitionId'"(selectionChange)="loadChosenManufactureProcess($event.value)">
                    <ng-container *ngFor="let column of getManufactureColumns(); trackBy: trackByFn">
                      <mat-option [value]="column.manufactureProcessColumnDefinitionId">
                        {{ column.name }}
                      </mat-option>
                    </ng-container>
                  </mat-select>
                </mat-form-field>
                <mat-label *ngIf="selectedProcess" class="col-span-3 -mt-2">Expected Build Time: {{getHoursText(getManufactureProcessTotal() / 60)}}</mat-label>
              </div>
            </div> -->
                        @if (deal?.dateSinceSwimlaneChange) {
                        <div
                            class="px-5 py-2 w-full flex gap-4 justify-between"
                        >
                            <div
                                class="flex"
                                [class.text-red-600]="slaDate && now > slaDate"
                            >
                                <mat-icon
                                    class="icon-size-6 mr-2"
                                    [svgIcon]="'mat_outline:timer'"
                                ></mat-icon>
                                <span class="text-lg">
                                    Moved to Swimlane:
                                    {{
                                        deal.dateSinceSwimlaneChange
                                            | date: "d MMM, yyyy"
                                    }}
                                    <br />{{ getDaysInSwimlane() }} ago
                                </span>
                            </div>
                            @if (slaDate) {
                            <div
                                class="flex"
                                [class.text-red-600]="slaDate && now > slaDate"
                            >
                                <mat-icon
                                    class="icon-size-6 mr-2"
                                    [svgIcon]="
                                        'heroicons_outline:calendar-days'
                                    "
                                ></mat-icon>
                                <span class="text-lg"
                                    >SLA:
                                    {{ slaDate | date: "d MMM, yyyy" }} ({{
                                        getSlaDays()
                                    }}
                                    day{{ getSlaDays() == 1 ? "" : "s" }})</span
                                >
                            </div>
                            }
                        </div>
                        }
                        <!-- Quote Information -->
                        <div
                            class="border rounded-2xl p-5 grid sm:grid-cols-4 gap-x-6 gap-y-4 w-full bg-[#f8f8f8]"
                        >
                            <div class="col-span-2 text-xl">Quote Overview</div>
                            <mat-form-field
                                class="sm:col-span-4 fuse-mat-dense"
                                subscriptSizing="dynamic"
                                floatLabel="always"
                            >
                                <mat-label>Quote Title</mat-label>
                                <input
                                    (change)="
                                        customerForm?.valid &&
                                            save(
                                                true,
                                                false,
                                                deal?.isWizardInFirstStage
                                            )
                                    "
                                    matInput
                                    [formControlName]="'name'"
                                    placeholder="Quote title will be automatically generated from Quote Ref, Company Name and Customer Ref"
                                />
                            </mat-form-field>
                            <mat-form-field
                                class="fuse-mat-dense"
                                subscriptSizing="dynamic"
                            >
                                <mat-label>Quote Ref</mat-label>
                                <input
                                    disabled
                                    [value]="
                                        deal?.quoteNumber ||
                                        deal?.quoteRef ||
                                        ''
                                    "
                                    matInput
                                />
                            </mat-form-field>
                            <mat-form-field
                                class="fuse-mat-dense"
                                subscriptSizing="dynamic"
                            >
                                <mat-label>Customer Ref</mat-label>
                                <input
                                    (change)="
                                        regenTitle() &&
                                            customerForm?.valid &&
                                            save(
                                                true,
                                                false,
                                                deal?.isWizardInFirstStage
                                            )
                                    "
                                    [formControlName]="'customerReqNo'"
                                    matInput
                                />
                            </mat-form-field>
                            <mat-form-field
                                class="w-full fuse-mat-dense"
                                subscriptSizing="dynamic"
                            >
                                <mat-label>Category</mat-label>
                                <mat-select
                                    multiple
                                    [formControlName]="'dealCategories'"
                                >
                                    @for (category of categories; track
                                    category) {
                                    <mat-option
                                        [value]="category.value"
                                        (onSelectionChange)="
                                            onCategoryToggled(
                                                $event,
                                                category.value
                                            )
                                        "
                                    >
                                        {{ category.name }}
                                    </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field
                                class="fuse-mat-dense"
                                subscriptSizing="dynamic"
                            >
                                <mat-label>Expected Close Date</mat-label>
                                <input
                                    (dateChange)="
                                        customerForm?.valid &&
                                            save(
                                                true,
                                                false,
                                                deal?.isWizardInFirstStage
                                            )
                                    "
                                    [formControlName]="'expectedCloseDate'"
                                    [matDatepicker]="closePicker"
                                    matInput
                                />
                                <mat-datepicker-toggle
                                    matIconSuffix
                                    [for]="closePicker"
                                ></mat-datepicker-toggle>
                                <mat-datepicker #closePicker></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <!-- Customer Information -->
                        <div
                            class="border rounded-2xl p-5 grid sm:grid-cols-2 gap-x-6 gap-y-4 w-full bg-[#f8f8f8]"
                        >
                            <div class="col-span-2 text-xl">
                                Customer Information
                            </div>
                            <div class="flex gap-4">
                                <mat-form-field
                                    class="flex-auto col-span-2 fuse-mat-dense"
                                    subscriptSizing="dynamic"
                                >
                                    <mat-label>Customer Name*</mat-label>
                                    <input
                                        matInput
                                        [matAutocomplete]="auto"
                                        [value]="selectedCompanyName"
                                        (input)="filterCompanies($event)"
                                    />
                                    <mat-autocomplete #auto="matAutocomplete">
                                        @for (company of filteredCompanies;
                                        track company) {
                                        <mat-option
                                            [value]="company.name"
                                            (onSelectionChange)="
                                                onCompanySelected(company)
                                            "
                                        >
                                            {{ company.name }}
                                        </mat-option>
                                        }
                                    </mat-autocomplete>
                                </mat-form-field>
                                <div class="mt-auto">
                                    <button mat-flat-button color="primary">
                                        <mat-icon
                                            class="icon-size-4 mr-1"
                                            svgIcon="heroicons_outline:receipt-refund"
                                        ></mat-icon>
                                        <span
                                            class="ml-1"
                                            (click)="openPastOrders()"
                                            >View Orders</span
                                        >
                                    </button>
                                </div>
                            </div>
                            <mat-form-field
                                class="fuse-mat-dense"
                                subscriptSizing="dynamic"
                            >
                                <mat-label>Contact</mat-label>
                                <mat-select
                                    (selectionChange)="
                                        customerForm?.valid &&
                                            save(
                                                true,
                                                false,
                                                deal?.isWizardInFirstStage
                                            )
                                    "
                                    [formControlName]="'contactId'"
                                    #contactSelect="matSelect"
                                >
                                    @for (contact of getCompanyContacts(); track
                                    trackByFn($index, contact)) {
                                    <mat-option [value]="contact?.id">
                                        {{ contact?.name }}
                                    </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                            <div>
                                <mat-label>Email Address</mat-label>
                                <div
                                    class="h-[42px] w-full border rounded-lg bg-card px-4 mt-[3px] flex flex-col justify-center"
                                >
                                    {{ getContactEmail() }}
                                </div>
                            </div>
                            <div>
                                <mat-label>Phone Number</mat-label>
                                <div
                                    class="h-[42px] w-full border rounded-lg bg-card px-4 mt-[3px] flex flex-col justify-center"
                                >
                                    {{ getContactPhoneNumber() }}
                                </div>
                            </div>
                            <mat-form-field
                                class="col-span-2 fuse-mat-dense"
                                subscriptSizing="dynamic"
                            >
                                <mat-label
                                    >Invoicing Address / VAT Rate</mat-label
                                >
                                <mat-select
                                    [formControlName]="'invoiceAddressId'"
                                    (selectionChange)="
                                        onCompanyInvoiceAddressChange($event)
                                    "
                                >
                                    @for (address of
                                    getCompanyInvoiceAddresses(); track
                                    trackByFn($index, address)) {
                                    <mat-option
                                        [value]="address.customerAddressId"
                                    >
                                        {{ formatInvoiceAddress(address) }} -
                                        {{
                                            address.vatRate * 100
                                                | number: "1.0"
                                        }}%
                                    </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                            <div class="col-span-2">
                                <mat-label>Street Address</mat-label>
                                <div
                                    class="h-[42px] w-full border rounded-lg bg-card px-4 mt-[3px] flex flex-col justify-center"
                                >
                                    {{ getCompany()?.address }}
                                </div>
                            </div>
                            <div>
                                <mat-label>City</mat-label>
                                <div
                                    class="h-[42px] w-full border rounded-lg bg-card px-4 mt-[3px] flex flex-col justify-center"
                                ></div>
                            </div>
                            <div>
                                <mat-label>State/County</mat-label>
                                <div
                                    class="h-[42px] w-full border rounded-lg bg-card px-4 mt-[3px] flex flex-col justify-center"
                                ></div>
                            </div>
                            <div>
                                <mat-label>Postal Code</mat-label>
                                <div
                                    class="h-[42px] w-full border rounded-lg bg-card px-4 mt-[3px] flex flex-col justify-center"
                                >
                                    {{ getCompany()?.postcode }}
                                </div>
                            </div>
                            <div>
                                <mat-label>Country</mat-label>
                                <div
                                    class="h-[42px] w-full border rounded-lg bg-card px-4 mt-[3px] flex flex-col justify-center"
                                ></div>
                            </div>
                            <mat-form-field
                                class="col-span-2 fuse-mat-dense"
                                subscriptSizing="dynamic"
                            >
                                <mat-label>Notes</mat-label>
                                <textarea
                                    (change)="
                                        customerForm?.valid &&
                                            save(
                                                true,
                                                false,
                                                deal?.isWizardInFirstStage
                                            )
                                    "
                                    matInput
                                    [formControlName]="'notes'"
                                    [rows]="2"
                                    cdkTextareaAutosize
                                    [cdkAutosizeMinRows]="2"
                                >
                                </textarea>
                            </mat-form-field>
                            <!-- Reporting-only flag: persisted on the deal, no
                                 behavioural effect. -->
                            <mat-checkbox
                                class="col-span-2"
                                color="primary"
                                [formControlName]="'isConsignmentStock'"
                                (change)="
                                    customerForm?.valid &&
                                        save(
                                            true,
                                            false,
                                            deal?.isWizardInFirstStage
                                        )
                                "
                            >
                                Consignment Stock
                            </mat-checkbox>
                        </div>
                        <!-- Attachments -->
                        <div
                            class="border rounded-2xl p-5 flex flex-col gap-4 w-full bg-[#f8f8f8]"
                        >
                            <div class="text-xl">Attachments</div>
                            <div
                                class="w-full flex flex-row flex-0 overflow-x-auto overflow-y-hidden"
                                style="height: 102px"
                            >
                                <div>
                                    <!--class="-ml-2"-->
                                    <!-- Upload file -->
                                    <button
                                        mat-icon-button
                                        (click)="openFileUpload()"
                                    >
                                        <mat-icon
                                            class="icon-size-5"
                                            [svgIcon]="
                                                'heroicons_solid:paper-clip'
                                            "
                                        ></mat-icon>
                                    </button>
                                </div>
                                <!-- Files -->
                                @if (fileInfos?.length > 0) { @for (file of
                                fileInfos; track file) { @if (!file.isBom) {
                                <div class="file-container p-2 mx-1">
                                    <!-- Icons -->
                                    <div
                                        [class.cursor-pointer]="dealId"
                                        class="relative text-center"
                                        (click)="dealId && download(file)"
                                    >
                                        <div
                                            class="inline-block relative text-center"
                                        >
                                            <mat-icon
                                                class="icon-size-14 text-hint opacity-50"
                                                [svgIcon]="
                                                    'heroicons_solid:document'
                                                "
                                            ></mat-icon>
                                            <div
                                                class="absolute left-0 bottom-0 px-1.5 rounded text-sm font-semibold leading-5 text-white"
                                                [class.bg-red-600]="
                                                    file.type == '.pdf'
                                                "
                                                [class.bg-blue-600]="
                                                    file.type == '.doc'
                                                "
                                                [class.bg-green-600]="
                                                    file.type == '.xls'
                                                "
                                                [class.bg-gray-600]="
                                                    file.type == '.txt'
                                                "
                                                [class.bg-amber-600]="
                                                    file.type == '.jpg'
                                                "
                                                [class.bg-yellow-500]="
                                                    file.type == '.png'
                                                "
                                            >
                                                {{ file.type.toUpperCase() }}
                                            </div>
                                            @if (!isBasic) {
                                            <button
                                                class="absolute"
                                                (click)="
                                                    deleteFile(file, $event)
                                                "
                                            >
                                                <mat-icon
                                                    class="icon-size-2 text-red-600"
                                                    >close</mat-icon
                                                >
                                            </button>
                                            }
                                        </div>
                                    </div>
                                    <div
                                        [class.cursor-pointer]="dealId"
                                        class="file-name text-s text-center mt-1"
                                        (click)="dealId && download(file)"
                                    >
                                        {{ file.name }}
                                    </div>
                                </div>
                                } } }
                            </div>
                        </div>
                        <!-- History / Activity Log -->
                        @if (dealId) {
                        <div
                            class="border rounded-2xl p-5 flex flex-col w-full bg-[#f8f8f8]"
                        >
                            <div class="text-xl">History</div>
                            @for (history of deal?.history; track history) {
                            <div
                                class="italic whitespace-pre-line mt-6"
                                [innerHTML]="history.description"
                            ></div>
                            <div class="text-sm mt-2" style="color: black">
                                {{
                                    history.timeStamp
                                        | date: "d MMM yyyy, h:mm a"
                                }}
                            </div>
                            } @if (!deal?.history?.length) { No activity logs
                            found. }
                        </div>
                        }
                        <div class="flex justify-end gap-4">
                            <!--
                        Step 1 actions — three mutually exclusive lifecycle states:
                        1. Sales hasn't handed off yet (new quote or in-progress draft):
                        shows TWO buttons:
                        - Save Progress (secondary): save(true, true, false) —
                        persists the draft as in-progress but leaves
                        isWizardInFirstStage = false, so the card stays default
                        colour. Use when sales is interrupted and wants to come
                        back to it themselves.
                        - Submit to Technician (primary): save(true, true, true) —
                        persists AND sets isWizardInFirstStage = true, which
                        drives the orange card colour on the pipeline board
                        (pipeline-board.component.html keys on this flag). Use
                        when sales is done with their part and handing off.
                        2. Quote has been handed off (isWizardInFirstStage = true):
                        technician is viewing. Show "Continue to BOM" (or "Continue"
                        for non-custom quotes), which is plain matStepperNext to
                        advance to the Build Product step.
                        3. Quote is past the wizard entirely (completed/closed):
                        plain "Next" for navigation.
                        -->
                            @if ((!dealId || deal?.isWizardInProgress) &&
                            !deal?.isWizardInFirstStage) {
                            <button
                                mat-stroked-button
                                type="button"
                                [disabled]="!customerForm?.valid"
                                (click)="save(true, true, false)"
                            >
                                Save Progress
                            </button>
                            } @if ((!dealId || deal?.isWizardInProgress) &&
                            !deal?.isWizardInFirstStage &&
                            getDealType() != DealType.Standard) {
                            <button
                                mat-flat-button
                                type="button"
                                [color]="'primary'"
                                [disabled]="!customerForm?.valid"
                                (click)="submitToTechnician()"
                            >
                                Submit to Technician
                            </button>
                            } @if ((!dealId || deal?.isWizardInProgress) &&
                            !deal?.isWizardInFirstStage &&
                            getDealType() == DealType.Standard) {
                            <button
                                mat-flat-button
                                matStepperNext
                                type="button"
                                [color]="'primary'"
                                [disabled]="!customerForm?.valid"
                                (click)="save(true, false, false)"
                            >
                                Continue
                            </button>
                            } @if (deal?.isWizardInFirstStage) {
                            <button
                                mat-flat-button
                                matStepperNext
                                type="button"
                                [color]="'primary'"
                                [disabled]="!customerForm?.valid"
                            >
                                {{
                                    isCustomQuote()
                                        ? "Continue to BOM"
                                        : "Continue"
                                }}
                            </button>
                            } @if (dealId && !deal?.isWizardInProgress &&
                            !deal?.isWizardInFirstStage) {
                            <button
                                mat-flat-button
                                matStepperNext
                                type="button"
                                [color]="'primary'"
                                [disabled]="!customerForm?.valid"
                            >
                                Next
                            </button>
                            }
                        </div>
                    </div>
                </form>
                }
            </mat-step>

            <!-- Products Step -->
            <mat-step
                [label]="
                    isCustomQuote()
                        ? 'Build Product'
                        : getDealType() == DealType.Calibration
                        ? 'Select Loadcells'
                        : getDealType() == DealType.Hire
                        ? 'Select Assets'
                        : getDealType() == DealType.Marine
                        ? 'Add Line Items'
                        : 'Select Products'
                "
                [stepControl]="productsForm"
            >
                <div class="w-full flex flex-col gap-4">
                    <div
                        class="mt-4 border rounded-2xl p-5 flex flex-col gap-4 w-full bg-[#f8f8f8]"
                    >
                        <div class="text-xl">Order Type</div>

                        <mat-radio-group
                            [value]="getOrderType()"
                            (change)="changeQuoteType($event)"
                            class="grid grid-cols-6 gap-4"
                            color="primary"
                        >
                            <mat-radio-button
                                [value]="0"
                                class="border border-2 rounded-lg p-3 bg-white cursor-pointer"
                                [class.border-[var(--fuse-primary)]]="
                                    getDealType() == DealType.Standard
                                "
                                (click)="changeQuoteType({ value: 0 })"
                            >
                                <div class="cursor-pointer">
                                    <div class="leading-[1]">
                                        Standard Product
                                    </div>
                                    <div class="text-sm leading-[1]">
                                        From product register
                                    </div>
                                </div>
                            </mat-radio-button>
                            <mat-radio-button
                                [value]="1"
                                class="border border-2 rounded-lg p-3 bg-white cursor-pointer"
                                [class.border-[var(--fuse-primary)]]="
                                    getDealType() == DealType.RepeatCustom
                                "
                                (click)="changeQuoteType({ value: 1 })"
                            >
                                <div class="cursor-pointer">
                                    <div class="leading-[1]">Repeat Custom</div>
                                    <div class="text-sm leading-[1]">
                                        Previously built product
                                    </div>
                                </div>
                            </mat-radio-button>
                            <mat-radio-button
                                [value]="2"
                                class="border border-2 rounded-lg p-3 bg-white cursor-pointer"
                                [class.border-[var(--fuse-primary)]]="
                                    getDealType() == DealType.Custom
                                "
                                (click)="changeQuoteType({ value: 2 })"
                            >
                                <div class="cursor-pointer">
                                    <div class="leading-[1]">
                                        Custom Product
                                    </div>
                                    <div class="text-sm leading-[1]">
                                        Bespoke configuration
                                    </div>
                                </div>
                            </mat-radio-button>

                            <mat-radio-button
                                [value]="3"
                                class="border border-2 rounded-lg p-3 bg-white cursor-pointer"
                                [class.border-[var(--fuse-primary)]]="
                                    getDealType() == DealType.Calibration
                                "
                                (click)="changeQuoteType({ value: 3 })"
                            >
                                <div class="cursor-pointer">
                                    <div class="leading-[1]">
                                        Calibration Quote
                                    </div>
                                    <div class="text-sm leading-[1]">
                                        Calibrate loadcells
                                    </div>
                                </div>
                            </mat-radio-button>
                            <mat-radio-button
                                [value]="4"
                                class="border border-2 rounded-lg p-3 bg-white cursor-pointer"
                                [class.border-[var(--fuse-primary)]]="
                                    getDealType() == DealType.Hire
                                "
                                (click)="changeQuoteType({ value: 4 })"
                            >
                                <div class="cursor-pointer">
                                    <div class="leading-[1]">Hire</div>
                                    <div class="text-sm leading-[1]">
                                        Hire assets
                                    </div>
                                </div>
                            </mat-radio-button>
                            <mat-radio-button
                                [value]="5"
                                class="border border-2 rounded-lg p-3 bg-white cursor-pointer"
                                [class.border-[var(--fuse-primary)]]="
                                    getDealType() == DealType.Marine
                                "
                                (click)="changeQuoteType({ value: 5 })"
                            >
                                <div class="cursor-pointer">
                                    <div class="leading-[1]">Marine Sales</div>
                                    <div class="text-sm leading-[1]">
                                        Custom marine products
                                    </div>
                                </div>
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>

                    <div
                        class="border rounded-2xl p-5 gap-4 w-full bg-[#f8f8f8] grid grid-cols-5"
                    >
                        <div class="col-span-5 flex justify-between">
                            <div class="text-xl">
                                {{
                                    isCustomQuote()
                                        ? "Build Custom Product"
                                        : getDealType() == DealType.Calibration
                                        ? "Select Loadcells"
                                        : getDealType() == DealType.Hire
                                        ? "Select Assets"
                                        : getDealType() == DealType.Marine
                                        ? "Add Line Items"
                                        : "Select Products"
                                }}
                            </div>
                            @if (getDealType() == DealType.Standard ||
                            getDealType() == DealType.Hire || getDealType() ==
                            DealType.RepeatCustom || getDealType() ==
                            DealType.Calibration) {
                            <input
                                matInput
                                [placeholder]="
                                    isCustomQuote()
                                        ? 'Search parts...'
                                        : getDealType() == DealType.Calibration
                                        ? 'Search loadcells...'
                                        : getDealType() == DealType.Hire
                                        ? 'Search assets...'
                                        : 'Search products...'
                                "
                                class="h-[42px] border rounded-lg bg-card px-4 mt-[3px] flex flex-col justify-center"
                                (input)="
                                    isCustomQuote()
                                        ? filterParts($event)
                                        : getDealType() == DealType.Calibration
                                        ? filterLoadcells($event)
                                        : getDealType() == DealType.Hire
                                        ? filterAssets($event)
                                        : filterProducts($event)
                                "
                            />
                            } @if (isCustomQuote()) {
                            <div class="flex items-center gap-2">
                                <span>Product Name:</span>
                                <input
                                    matInput
                                    [placeholder]="'New Product Name'"
                                    class="h-[42px] border rounded-lg bg-card px-4 mt-[3px] flex flex-col justify-center min-w-[300px]"
                                    [(ngModel)]="customProductName"
                                />
                                <span class="ml-2">Product Number:</span>
                                <input
                                    matInput
                                    disabled
                                    readonly
                                    [placeholder]="'New Product Number'"
                                    class="h-[42px] border rounded-lg bg-card px-4 mt-[3px] flex flex-col justify-center w-[120px]"
                                    style="color: #00000061 !important"
                                    [(ngModel)]="customProductPartNumber"
                                />
                            </div>
                            }
                        </div>

                        <!-- Product/Part Register -->
                        @if (getDealType() == DealType.Standard || getDealType()
                        == DealType.Hire || getDealType() ==
                        DealType.RepeatCustom || getDealType() ==
                        DealType.Calibration) {
                        <div class="border rounded-xl bg-white col-span-2 p-4">
                            <div>
                                {{
                                    isCustomQuote()
                                        ? "Part"
                                        : getDealType() == DealType.Calibration
                                        ? "Loadcell"
                                        : getDealType() == DealType.Hire
                                        ? "Asset"
                                        : "Product"
                                }}
                                Register
                            </div>
                            <div
                                class="flex flex-col gap-2 py-3 h-[calc(100vh-690px)] overflow-y-scroll"
                                cdkScrollable
                                (scroll)="onScroll($event)"
                                style="scrollbar-gutter: stable"
                            >
                                <!-- Products -->
                                @if (getDealType() == DealType.Standard ||
                                getDealType() == DealType.RepeatCustom) { @for
                                (product of filteredProducts; track
                                trackByFn($index, product)) {
                                <div
                                    class="border rounded-md p-3 flex gap-2 items-center"
                                >
                                    <div class="flex-auto">
                                        <div
                                            class="flex gap-4 mb-1 items-center"
                                        >
                                            <div>
                                                {{ product.partNumber | productNumber }}
                                            </div>
                                            <div
                                                class="bg-[#f8f8f8] py-1 px-2 rounded-md text-sm"
                                            >
                                                {{ product.freeStock }} in stock
                                            </div>
                                        </div>
                                        <div class="text-md">
                                            {{ product.description }}
                                        </div>
                                    </div>
                                    <div>
                                        <button
                                            mat-stroked-button
                                            (click)="
                                                openProductOverview(product)
                                            "
                                        >
                                            Overview
                                        </button>
                                    </div>
                                    <div class="flex items-center">
                                        @if (!productIsSelected(product)) {
                                        <button
                                            mat-flat-button
                                            color="primary"
                                            (click)="addProduct(product)"
                                        >
                                            Add
                                        </button>
                                        } @if (productIsSelected(product)) {
                                        <mat-icon
                                            class="text-green-500 icon-size-4 ml-1"
                                            svgIcon="feather:check"
                                        ></mat-icon>
                                        } @if (productIsSelected(product)) {
                                        <span
                                            class="ml-1 text-green-500 text-md"
                                            >Added</span
                                        >
                                        }
                                    </div>
                                </div>
                                } }
                                <!--
                              Parts side-panel browser. Since the bulk parts endpoint now
                              returns all revisions (not just verified), each rev appears as
                              its own card. formatPartLabel appends "Rev N" so 5 cards for a
                              5-rev part are distinguishable rather than visually identical.
                              -->
                                @if (isCustomQuote()) { @for (part of
                                filteredParts; track trackByFn($index, part)) {
                                <div
                                    class="border rounded-md p-3 flex gap-2 items-center"
                                >
                                    <div class="flex-auto">
                                        <div
                                            class="flex gap-4 mb-1 items-center"
                                        >
                                            <div
                                                class="flex gap-1 items-center"
                                            >
                                                <span>{{
                                                    formatPartLabel(part)
                                                }}</span>
                                                @if (part.isVerifiedVersion &&
                                                part.partVersionsId &&
                                                part.sisterParts?.length > 1) {
                                                <mat-icon
                                                    [matTooltip]="
                                                        'Verified revision'
                                                    "
                                                    [style.color]="'#12df12'"
                                                    class="icon-size-4 m-0"
                                                    svgIcon="mat_solid:verified"
                                                ></mat-icon>
                                                } @if (part.isHighRisk) {
                                                <mat-icon
                                                    [matTooltip]="'High Risk'"
                                                    color="warn"
                                                    class="icon-size-5 m-0"
                                                    svgIcon="mat_solid:warning"
                                                ></mat-icon>
                                                } @if (part.isCritical) {
                                                <mat-icon
                                                    [matTooltip]="
                                                        'Critical Component'
                                                    "
                                                    color="warn"
                                                    class="icon-size-5 m-0"
                                                    svgIcon="mat_solid:flag"
                                                ></mat-icon>
                                                } @if (part.currentStock <
                                                part.minimumStock) {
                                                <mat-icon
                                                    [matTooltip]="
                                                        'Stock under Minimum'
                                                    "
                                                    color="warn"
                                                    class="icon-size-5"
                                                    svgIcon="mat_solid:remove_shopping_cart"
                                                ></mat-icon>
                                                }
                                            </div>
                                            <div
                                                class="bg-[#f8f8f8] py-1 px-2 rounded-md text-sm"
                                            >
                                                {{ part.currentStock }} in stock
                                            </div>
                                        </div>
                                        <div class="text-md">
                                            {{ part.description }}
                                        </div>
                                    </div>
                                    <div>
                                        <button mat-stroked-button>
                                            Overview
                                        </button>
                                    </div>
                                    <div class="flex items-center">
                                        @if (!partIsSelected(part)) {
                                        <button
                                            mat-flat-button
                                            color="primary"
                                            (click)="addPart(part)"
                                        >
                                            Add
                                        </button>
                                        } @if (partIsSelected(part)) {
                                        <mat-icon
                                            class="text-green-500 icon-size-4 ml-1"
                                            svgIcon="feather:check"
                                        ></mat-icon>
                                        } @if (partIsSelected(part)) {
                                        <span class="text-green-500 text-md"
                                            >Added</span
                                        >
                                        }
                                    </div>
                                </div>
                                } }
                                <!-- Loadcells -->
                                @if (getDealType() == DealType.Calibration) {
                                @for (loadcell of filteredLoadcells; track
                                trackByFn($index, loadcell)) {
                                <div
                                    class="border rounded-md p-3 flex gap-2 items-center"
                                >
                                    <div class="flex-auto">
                                        <div
                                            class="flex gap-4 mb-1 items-center"
                                        >
                                            <div
                                                class="flex gap-1 items-center"
                                            >
                                                <span>{{
                                                    loadcell.bookingRef
                                                }}</span>
                                            </div>
                                            <!-- <div class="bg-[#f8f8f8] py-1 px-2 rounded-md text-sm">{{part.currentStock}} in stock</div> -->
                                        </div>
                                        <div class="text-md">
                                            {{ loadcell.customerName }}
                                        </div>
                                    </div>
                                    <div>
                                        <button
                                            mat-stroked-button
                                            (click)="
                                                openLoadcellOverview(
                                                    loadcell.loadcellId
                                                )
                                            "
                                        >
                                            Overview
                                        </button>
                                    </div>
                                    <div class="flex items-center">
                                        @if (!loadcellIsSelected(loadcell)) {
                                        <button
                                            mat-flat-button
                                            color="primary"
                                            (click)="addLoadcell(loadcell)"
                                        >
                                            Add
                                        </button>
                                        } @if (loadcellIsSelected(loadcell)) {
                                        <mat-icon
                                            class="text-green-500 icon-size-4 ml-1"
                                            svgIcon="feather:check"
                                        ></mat-icon>
                                        } @if (loadcellIsSelected(loadcell)) {
                                        <span class="text-green-500 text-md"
                                            >Added</span
                                        >
                                        }
                                    </div>
                                </div>
                                } }
                                <!-- Assets -->
                                @if (getDealType() == DealType.Hire) { @for
                                (asset of filteredAssets; track
                                trackByFn($index, asset)) {
                                <div
                                    class="border rounded-md p-3 flex gap-2 items-center"
                                >
                                    <div class="flex-auto">
                                        <div
                                            class="flex gap-4 mb-1 items-center"
                                        >
                                            <div>{{ asset.serialNumber }}</div>
                                            <div
                                                class="bg-[#f8f8f8] py-1 px-2 rounded-md text-sm"
                                            >
                                                {{ asset.stock }} in stock
                                            </div>
                                        </div>
                                        <div class="text-md">
                                            {{ asset.name }}
                                        </div>
                                    </div>
                                    <div>
                                        <button
                                            mat-stroked-button
                                            (click)="openAssetOverview(asset)"
                                        >
                                            Overview
                                        </button>
                                    </div>
                                    <div class="flex items-center">
                                        @if (!assetIsSelected(asset)) {
                                        <button
                                            mat-flat-button
                                            color="primary"
                                            (click)="addAsset(asset)"
                                        >
                                            Add
                                        </button>
                                        } @if (assetIsSelected(asset)) {
                                        <mat-icon
                                            class="text-green-500 icon-size-4 ml-1"
                                            svgIcon="feather:check"
                                        ></mat-icon>
                                        } @if (assetIsSelected(asset)) {
                                        <span
                                            class="ml-1 text-green-500 text-md"
                                            >Added</span
                                        >
                                        }
                                    </div>
                                </div>
                                } }
                            </div>
                        </div>
                        }

                        <!-- Custom: prompt to enter Product Name before the BOM area is interactive -->
                        @if (isCustomQuote() && !customProductName?.trim()) {
                        <div
                            class="border rounded-xl bg-amber-50 text-amber-800 col-span-5 p-4 flex items-center gap-2"
                        >
                            <mat-icon
                                class="icon-size-5 text-amber-700"
                                svgIcon="heroicons_outline:exclamation-triangle"
                            ></mat-icon>
                            <span
                                >Enter a <strong>Product Name</strong> above to
                                start building the BOM.</span
                            >
                        </div>
                        }

                        <!-- Chosen Products/Parts - Line Items -->
                        <div
                            class="border rounded-xl bg-white col-span-3 p-4"
                            [class.col-span-5]="
                                isCustomQuote() ||
                                getDealType() == DealType.Marine
                            "
                            [class.px-0]="isCustomQuote()"
                            [class.opacity-50]="
                                isCustomQuote() && !customProductName?.trim()
                            "
                            [class.pointer-events-none]="
                                isCustomQuote() && !customProductName?.trim()
                            "
                        >
                            @if (!isCustomQuote()) {
                            <div [class.px-4]="isCustomQuote()">
                                Selected
                                {{
                                    isCustomQuote()
                                        ? "Parts"
                                        : getDealType() == DealType.Calibration
                                        ? "Loadcells"
                                        : getDealType() == DealType.Hire
                                        ? "Assets"
                                        : getDealType() == DealType.Marine
                                        ? "Items"
                                        : "Products"
                                }}
                            </div>
                            } @if (productsForm) {
                            <form
                                [formGroup]="productsForm"
                                class="flex flex-col gap-2 py-3"
                                [class.h-[calc(100vh-690px)]]="!isCustomQuote()"
                                [class.overflow-y-scroll]="!isCustomQuote()"
                            >
                                @if (getDealType() == DealType.Standard ||
                                getDealType() == DealType.RepeatCustom &&
                                productItems?.controls) {
                                <ng-container formArrayName="productLines">
                                    @for (itemControl of productItems?.controls;
                                    track itemControl; let i = $index) {
                                    <ng-container [formGroupName]="i">
                                        <div
                                            class="border rounded-md p-3 flex gap-2 items-center"
                                        >
                                            <div class="flex-auto">
                                                <div
                                                    class="flex gap-4 mb-1 items-center"
                                                >
                                                    <div>
                                                        {{
                                                            lookupProduct(
                                                                itemControl
                                                            )?.partNumber
                                                                | productNumber
                                                        }}
                                                    </div>
                                                    <div
                                                        class="bg-[#f8f8f8] py-1 px-2 rounded-md text-sm"
                                                    >
                                                        {{
                                                            lookupProduct(
                                                                itemControl
                                                            )?.freeStock
                                                        }}
                                                        in stock
                                                    </div>
                                                </div>
                                                <div class="text-md">
                                                    {{
                                                        lookupProduct(
                                                            itemControl
                                                        )?.description
                                                    }}
                                                </div>
                                            </div>
                                            <div>
                                                <mat-form-field
                                                    class="fuse-mat-dense max-w-[100px]"
                                                    subscriptSizing="dynamic"
                                                >
                                                    <mat-label>Qty</mat-label>
                                                    <input
                                                        matInput
                                                        type="number"
                                                        [formControlName]="
                                                            'quantity'
                                                        "
                                                        (change)="
                                                            productsForm?.valid &&
                                                                save(
                                                                    true,
                                                                    false,
                                                                    deal?.isWizardInFirstStage
                                                                )
                                                        "
                                                    />
                                                </mat-form-field>
                                            </div>
                                            <div>
                                                <mat-form-field
                                                    class="fuse-mat-dense max-w-[100px]"
                                                    subscriptSizing="dynamic"
                                                >
                                                    <mat-label>Price</mat-label>
                                                    <input
                                                        matInput
                                                        [value]="
                                                            (
                                                                itemControl
                                                                    .controls[
                                                                    'cost'
                                                                ].value ?? 0
                                                            ).toFixed(2)
                                                        "
                                                        disabled
                                                    />
                                                    <span matPrefix>£</span>
                                                </mat-form-field>
                                            </div>
                                            <!-- <div>
                                          <mat-form-field class="fuse-mat-dense max-w-[100px]" subscriptSizing="dynamic">
                                            <mat-label>Discount</mat-label>
                                            <input matInput type="number" [formControlName]="'discount'"
                                              (change)="productsForm?.valid && save(true, false, deal?.isWizardInFirstStage)">
                                              <span matPrefix>£</span>
                                            </mat-form-field>
                                          </div> -->
                                            <div class="mt-auto">
                                                <button
                                                    mat-icon-button
                                                    (click)="
                                                        deleteProductItem(i)
                                                    "
                                                >
                                                    <mat-icon
                                                        svgIcon="heroicons_outline:x-mark"
                                                        class="icon-size-5"
                                                    ></mat-icon>
                                                </button>
                                            </div>
                                        </div>
                                    </ng-container>
                                    }
                                </ng-container>
                                } @if (getDealType() == DealType.Hire &&
                                hireItems?.controls) {
                                <ng-container formArrayName="hireLines">
                                    @for (itemControl of hireItems?.controls;
                                    track itemControl; let i = $index) {
                                    <ng-container [formGroupName]="i">
                                        <div
                                            class="border rounded-md p-3 flex gap-2 items-center"
                                        >
                                            <div class="flex-auto">
                                                <div
                                                    class="flex gap-4 mb-1 items-center"
                                                >
                                                    <div>
                                                        {{
                                                            lookupAsset(
                                                                itemControl
                                                            )?.serialNumber
                                                        }}
                                                    </div>
                                                    <div
                                                        class="bg-[#f8f8f8] py-1 px-2 rounded-md text-sm"
                                                    >
                                                        {{
                                                            lookupAsset(
                                                                itemControl
                                                            )?.stock
                                                        }}
                                                        in stock
                                                    </div>
                                                </div>
                                                <div class="text-md">
                                                    {{
                                                        lookupAsset(itemControl)
                                                            ?.name
                                                    }}
                                                </div>
                                            </div>
                                            <div>
                                                <mat-form-field
                                                    class="fuse-mat-dense w-[140px]"
                                                    subscriptSizing="dynamic"
                                                >
                                                    <mat-label
                                                        >Hire From</mat-label
                                                    >
                                                    <input
                                                        (dateChange)="
                                                            productsForm?.valid &&
                                                                save(
                                                                    true,
                                                                    false,
                                                                    deal?.isWizardInFirstStage
                                                                )
                                                        "
                                                        [formControlName]="
                                                            'hireFrom'
                                                        "
                                                        [matDatepicker]="
                                                            pickerfrom
                                                        "
                                                        matInput
                                                    />
                                                    <mat-datepicker-toggle
                                                        matIconSuffix
                                                        [for]="pickerfrom"
                                                    ></mat-datepicker-toggle>
                                                    <mat-datepicker
                                                        #pickerfrom
                                                    ></mat-datepicker>
                                                </mat-form-field>
                                            </div>
                                            <div>
                                                <mat-form-field
                                                    class="fuse-mat-dense w-[140px]"
                                                    subscriptSizing="dynamic"
                                                >
                                                    <mat-label
                                                        >Hire To</mat-label
                                                    >
                                                    <input
                                                        (dateChange)="
                                                            productsForm?.valid &&
                                                                save(
                                                                    true,
                                                                    false,
                                                                    deal?.isWizardInFirstStage
                                                                )
                                                        "
                                                        [formControlName]="
                                                            'hireTo'
                                                        "
                                                        [matDatepicker]="
                                                            pickerto
                                                        "
                                                        matInput
                                                    />
                                                    <mat-datepicker-toggle
                                                        matIconSuffix
                                                        [for]="pickerto"
                                                    ></mat-datepicker-toggle>
                                                    <mat-datepicker
                                                        #pickerto
                                                    ></mat-datepicker>
                                                </mat-form-field>
                                            </div>
                                            <div>
                                                <mat-form-field
                                                    class="fuse-mat-dense max-w-[100px]"
                                                    subscriptSizing="dynamic"
                                                >
                                                    <mat-label>Price</mat-label>
                                                    <input
                                                        matInput
                                                        [value]="
                                                            (
                                                                lookupAsset(
                                                                    itemControl
                                                                )?.cost ?? 0
                                                            ).toFixed(2)
                                                        "
                                                        disabled
                                                    />
                                                    <span matPrefix>£</span>
                                                </mat-form-field>
                                            </div>
                                            <div class="mt-auto">
                                                <button
                                                    mat-icon-button
                                                    (click)="deleteHireItem(i)"
                                                >
                                                    <mat-icon
                                                        svgIcon="heroicons_outline:x-mark"
                                                        class="icon-size-5"
                                                    ></mat-icon>
                                                </button>
                                            </div>
                                        </div>
                                    </ng-container>
                                    }
                                </ng-container>
                                } @if (getDealType() == DealType.Calibration &&
                                calibrationItems?.controls) {
                                <ng-container formArrayName="calibrationLines">
                                    @for (itemControl of
                                    calibrationItems?.controls; track
                                    itemControl; let i = $index) {
                                    <ng-container [formGroupName]="i">
                                        <div
                                            class="border rounded-md p-3 flex gap-2 items-center"
                                        >
                                            <div class="flex-auto">
                                                <div
                                                    class="flex gap-4 mb-1 items-center"
                                                >
                                                    <div>
                                                        {{
                                                            lookupLoadcell(
                                                                itemControl
                                                            )?.bookingRef
                                                        }}
                                                    </div>
                                                    <!-- <div class="bg-[#f8f8f8] py-1 px-2 rounded-md text-sm">{{lookupLoadcell(itemControl)?.freeStock}} in stock</div> -->
                                                </div>
                                                <div class="text-md">
                                                    {{
                                                        lookupLoadcell(
                                                            itemControl
                                                        )?.customerCode
                                                    }}
                                                </div>
                                            </div>
                                            <div>
                                                <mat-form-field
                                                    class="fuse-mat-dense w-[200px]"
                                                    subscriptSizing="dynamic"
                                                >
                                                    <mat-label
                                                        >Description</mat-label
                                                    >
                                                    <input
                                                        matInput
                                                        [formControlName]="
                                                            'description'
                                                        "
                                                        (change)="
                                                            productsForm?.valid &&
                                                                save(
                                                                    true,
                                                                    false,
                                                                    deal?.isWizardInFirstStage
                                                                )
                                                        "
                                                    />
                                                </mat-form-field>
                                            </div>
                                            <div>
                                                <mat-form-field
                                                    class="fuse-mat-dense max-w-[100px]"
                                                    subscriptSizing="dynamic"
                                                >
                                                    <mat-label>Qty</mat-label>
                                                    <input
                                                        matInput
                                                        type="number"
                                                        [formControlName]="
                                                            'quantity'
                                                        "
                                                        (change)="
                                                            productsForm?.valid &&
                                                                save(
                                                                    true,
                                                                    false,
                                                                    deal?.isWizardInFirstStage
                                                                )
                                                        "
                                                    />
                                                </mat-form-field>
                                            </div>
                                            <div>
                                                <mat-form-field
                                                    class="fuse-mat-dense max-w-[100px]"
                                                    subscriptSizing="dynamic"
                                                >
                                                    <mat-label>Price</mat-label>
                                                    <input
                                                        matInput
                                                        type="number"
                                                        [formControlName]="
                                                            'cost'
                                                        "
                                                        (change)="
                                                            productsForm?.valid &&
                                                                save(
                                                                    true,
                                                                    false,
                                                                    deal?.isWizardInFirstStage
                                                                )
                                                        "
                                                    />
                                                    <span matPrefix>£</span>
                                                </mat-form-field>
                                            </div>
                                            <div>
                                                <mat-form-field
                                                    class="fuse-mat-dense max-w-[150px]"
                                                    subscriptSizing="dynamic"
                                                >
                                                    <mat-label>Notes</mat-label>
                                                    <input
                                                        matInput
                                                        [formControlName]="
                                                            'notes'
                                                        "
                                                        (change)="
                                                            productsForm?.valid &&
                                                                save(
                                                                    true,
                                                                    false,
                                                                    deal?.isWizardInFirstStage
                                                                )
                                                        "
                                                    />
                                                </mat-form-field>
                                            </div>
                                            <div class="mt-auto">
                                                <button
                                                    mat-icon-button
                                                    (click)="
                                                        deleteCalibrationItem(i)
                                                    "
                                                >
                                                    <mat-icon
                                                        svgIcon="heroicons_outline:x-mark"
                                                        class="icon-size-5"
                                                    ></mat-icon>
                                                </button>
                                            </div>
                                        </div>
                                    </ng-container>
                                    }
                                </ng-container>
                                } @if (getDealType() == DealType.Marine &&
                                marineItems?.controls) {
                                <ng-container formArrayName="marineLines">
                                    @for (itemControl of marineItems?.controls;
                                    track itemControl; let i = $index) {
                                    <ng-container [formGroupName]="i">
                                        <div
                                            class="border rounded-md p-3 flex gap-2 items-center"
                                        >
                                            <!-- <div class="flex-auto">
                                                      <mat-form-field class="fuse-mat-dense w-full" subscriptSizing="dynamic">
                                                        <mat-label>Part Number</mat-label>
                                                        <input matInput [formControlName]="'partNumber'"
                                                          (change)="productsForm?.valid && save(true, false, deal?.isWizardInFirstStage)">
                                                        </mat-form-field>
                                                      </div> -->
                                            <div class="flex-auto">
                                                <mat-form-field
                                                    class="fuse-mat-dense w-full"
                                                    subscriptSizing="dynamic"
                                                >
                                                    <mat-label
                                                        >Part Name</mat-label
                                                    >
                                                    <input
                                                        matInput
                                                        [formControlName]="
                                                            'partName'
                                                        "
                                                        [matAutocomplete]="
                                                            marinePartAuto
                                                        "
                                                        (input)="
                                                            filterMarineParts(
                                                                $event
                                                            )
                                                        "
                                                        (change)="
                                                            productsForm?.valid &&
                                                                save(
                                                                    true,
                                                                    false,
                                                                    deal?.isWizardInFirstStage
                                                                )
                                                        "
                                                    />
                                                    <mat-autocomplete
                                                        #marinePartAuto="matAutocomplete"
                                                    >
                                                        @for (marinePart of
                                                        filteredMarineParts;
                                                        track marinePart) {
                                                        <mat-option
                                                            [value]="
                                                                marinePart.partName
                                                            "
                                                            (onSelectionChange)="
                                                                onMarinePartSelected(
                                                                    marinePart,
                                                                    itemControl
                                                                )
                                                            "
                                                        >
                                                            {{
                                                                marinePart.partName
                                                            }}
                                                        </mat-option>
                                                        }
                                                    </mat-autocomplete>
                                                </mat-form-field>
                                            </div>
                                            <div
                                                class="flex-auto max-w-[220px]"
                                            >
                                                <mat-form-field
                                                    class="fuse-mat-dense w-full"
                                                    subscriptSizing="dynamic"
                                                >
                                                    <mat-label
                                                        >Supplier</mat-label
                                                    >
                                                    <input
                                                        matInput
                                                        [formControlName]="
                                                            'supplier'
                                                        "
                                                        (change)="
                                                            productsForm?.valid &&
                                                                save(
                                                                    true,
                                                                    false,
                                                                    deal?.isWizardInFirstStage
                                                                )
                                                        "
                                                    />
                                                </mat-form-field>
                                            </div>
                                            <div
                                                class="flex-auto max-w-[220px]"
                                            >
                                                <mat-form-field
                                                    class="fuse-mat-dense w-full"
                                                    subscriptSizing="dynamic"
                                                >
                                                    <mat-label
                                                        >Category</mat-label
                                                    >
                                                    <input
                                                        matInput
                                                        [formControlName]="
                                                            'category'
                                                        "
                                                        [matAutocomplete]="
                                                            marinePartCatAuto
                                                        "
                                                        (input)="
                                                            filterMarinePartCategories(
                                                                $event
                                                            )
                                                        "
                                                        (change)="
                                                            productsForm?.valid &&
                                                                save(
                                                                    true,
                                                                    false,
                                                                    deal?.isWizardInFirstStage
                                                                )
                                                        "
                                                    />
                                                    <mat-autocomplete
                                                        #marinePartCatAuto="matAutocomplete"
                                                    >
                                                        @for (cat of
                                                        filteredMarinePartCategories;
                                                        track cat) {
                                                        <mat-option
                                                            [value]="cat"
                                                            (onSelectionChange)="
                                                                productsForm?.valid &&
                                                                    save(
                                                                        true,
                                                                        false,
                                                                        deal?.isWizardInFirstStage
                                                                    )
                                                            "
                                                        >
                                                            {{ cat }}
                                                        </mat-option>
                                                        }
                                                    </mat-autocomplete>
                                                </mat-form-field>
                                            </div>
                                            <div>
                                                <mat-form-field
                                                    class="fuse-mat-dense max-w-[120px]"
                                                    subscriptSizing="dynamic"
                                                >
                                                    <mat-label>Qty</mat-label>
                                                    <input
                                                        matInput
                                                        type="number"
                                                        [formControlName]="
                                                            'quantity'
                                                        "
                                                        (change)="
                                                            productsForm?.valid &&
                                                                save(
                                                                    true,
                                                                    false,
                                                                    deal?.isWizardInFirstStage
                                                                )
                                                        "
                                                    />
                                                </mat-form-field>
                                            </div>
                                            <div>
                                                <mat-form-field
                                                    class="fuse-mat-dense max-w-[120px]"
                                                    subscriptSizing="dynamic"
                                                >
                                                    <mat-label>Cost</mat-label>
                                                    <input
                                                        matInput
                                                        type="number"
                                                        [formControlName]="
                                                            'internalCost'
                                                        "
                                                        (change)="
                                                            productsForm?.valid &&
                                                                save(
                                                                    true,
                                                                    false,
                                                                    deal?.isWizardInFirstStage
                                                                )
                                                        "
                                                    />
                                                    <span matPrefix>£</span>
                                                </mat-form-field>
                                            </div>
                                            <div>
                                                <mat-form-field
                                                    class="fuse-mat-dense max-w-[120px]"
                                                    subscriptSizing="dynamic"
                                                >
                                                    <mat-label>Price</mat-label>
                                                    <input
                                                        matInput
                                                        type="number"
                                                        [formControlName]="
                                                            'cost'
                                                        "
                                                        (change)="
                                                            productsForm?.valid &&
                                                                save(
                                                                    true,
                                                                    false,
                                                                    deal?.isWizardInFirstStage
                                                                )
                                                        "
                                                    />
                                                    <span matPrefix>£</span>
                                                </mat-form-field>
                                            </div>
                                            <!-- <div>
                                                                  <mat-form-field class="fuse-mat-dense max-w-[100px]" subscriptSizing="dynamic">
                                                                    <mat-label>Discount</mat-label>
                                                                    <input matInput type="number" [formControlName]="'discount'"
                                                                      (change)="productsForm?.valid && save(true, false, deal?.isWizardInFirstStage)">
                                                                      <span matPrefix>£</span>
                                                                    </mat-form-field>
                                                                  </div> -->
                                            <div class="mt-auto">
                                                <button
                                                    mat-icon-button
                                                    (click)="
                                                        deleteMarineItem(i)
                                                    "
                                                >
                                                    <mat-icon
                                                        svgIcon="heroicons_outline:x-mark"
                                                        class="icon-size-5"
                                                    ></mat-icon>
                                                </button>
                                            </div>
                                        </div>
                                    </ng-container>
                                    }
                                    <div class="flex justify-end">
                                        <button
                                            mat-flat-button
                                            color="primary"
                                            (click)="addMarineItem()"
                                        >
                                            Add
                                        </button>
                                    </div>
                                </ng-container>
                                } @if (isCustomQuote() && partItems?.controls) {
                                <ng-container formArrayName="partLines">
                                    <div class="ml-8 text-xl mb-2 -mt-2">
                                        Parts
                                    </div>
                                    <div class="flex flex-col divide-y">
                                        <div
                                            class="grid grid-cols-13 bg-gray-50 border-t py-2 px-6 gap-3 items-center uppercase text-md tracking-tight"
                                        >
                                            <span>#</span>
                                            <span class="col-span-3"
                                                >Part Number / Description</span
                                            >
                                            <span>Type</span>
                                            <span>Source</span>
                                            <span>Qty</span>
                                            <span>Unit</span>
                                            <span>Unit Cost</span>
                                            <span>Total Cost</span>
                                            <span>Stock Status</span>
                                            <span class="text-right col-span-2"
                                                >Actions</span
                                            >
                                        </div>
                                        <!-- Synthetic Product Row (Level 0) — read-only display of the custom product -->
                                        @if (hasProductRow()) {
                                        <div
                                            class="grid grid-cols-13 py-2 px-6 gap-3 items-center h-[59px] bg-gray-100"
                                        >
                                            <span class="text-secondary"
                                                >0</span
                                            >
                                            <div
                                                class="col-span-3 flex gap-2 items-center text-secondary"
                                            >
                                                <span class="line-clamp-2">{{
                                                    getProductRowLabel()
                                                }}</span>
                                            </div>
                                            <span
                                                class="rounded-full px-2 w-min text-sm whitespace-pre bg-blue-100 text-secondary"
                                                >ASSEMBLY</span
                                            >
                                            <span></span>
                                            <span class="text-secondary"
                                                >1</span
                                            >
                                            <span class="text-secondary"
                                                >EA</span
                                            >
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                            <span
                                                class="text-right col-span-2"
                                            ></span>
                                        </div>
                                        } @for (itemControl of
                                        partItems?.controls; track itemControl;
                                        let i = $index) {
                                        <ng-container [formGroupName]="i">
                                            <!--
                                                                  When this row's per-line assembly-process panel is
                                                                  expanded, tint the parent row with the same #fafafa
                                                                  background as the panel below so they read as one
                                                                  continuous block. Mirror of the BOM Builder's BOM
                                                                  row treatment.
                                                                  -->
                                            <div
                                                class="grid grid-cols-13 py-2 px-6 gap-3 items-center h-[59px] transition-[height]"
                                                [class.row-hidden]="
                                                    itemControl.controls[
                                                        'hidden'
                                                    ].value
                                                "
                                                [style.background-color]="
                                                    isLineProcessesExpanded(
                                                        getLineKey(itemControl)
                                                    )
                                                        ? '#fafafa'
                                                        : null
                                                "
                                            >
                                                <mat-form-field
                                                    class="fuse-mat-dense"
                                                    subscriptSizing="dynamic"
                                                >
                                                    <input
                                                        matInput
                                                        formControlName="level"
                                                        (blur)="reorderLevels()"
                                                        (input)="
                                                            constrainLevelFormat(
                                                                $event,
                                                                itemControl
                                                            )
                                                        "
                                                    />
                                                </mat-form-field>
                                                <div
                                                    class="col-span-3 flex gap-2 items-center"
                                                >
                                                    <span
                                                        [style]="
                                                            'padding-left: ' +
                                                            getLevelIndent(
                                                                itemControl
                                                            ) *
                                                                1.2 +
                                                            'rem;'
                                                        "
                                                    >
                                                        <mat-icon
                                                            class="icon-size-5"
                                                            [class.cursor-pointer]="
                                                                hasLevelChildren(
                                                                    itemControl
                                                                )
                                                            "
                                                            style="
                                                                vertical-align: middle;
                                                            "
                                                            [svgIcon]="
                                                                !hasLevelChildren(
                                                                    itemControl
                                                                )
                                                                    ? ''
                                                                    : areLevelChildrenHidden(
                                                                          itemControl
                                                                      )
                                                                    ? 'mat_outline:keyboard_arrow_right'
                                                                    : 'mat_outline:keyboard_arrow_down'
                                                            "
                                                            (click)="
                                                                hasLevelChildren(
                                                                    itemControl
                                                                ) &&
                                                                    toggleLevelChildrenHide(
                                                                        itemControl
                                                                    )
                                                            "
                                                        >
                                                        </mat-icon>
                                                    </span>
                                                    <mat-form-field
                                                        class="fuse-mat-dense w-full"
                                                        subscriptSizing="dynamic"
                                                    >
                                                        <input
                                                            matInput
                                                            formControlName="partId"
                                                            [matAutocomplete]="
                                                                partAuto
                                                            "
                                                            autocomplete="off"
                                                            (input)="
                                                                filterParts(
                                                                    $event
                                                                )
                                                            "
                                                            (focus)="
                                                                setupFilterParts(
                                                                    itemControl
                                                                )
                                                            "
                                                        />
                                                        <!--
                                                                        panelWidth="auto" lets the dropdown size to its
                                                                        content so the "Rev N" suffix stays visible.
                                                                        Mirror of bom-builder's autocomplete.
                                                                        -->
                                                        <mat-autocomplete
                                                            #partAuto="matAutocomplete"
                                                            [displayWith]="
                                                                displayPart
                                                            "
                                                            autoActiveFirstOption
                                                            [requireSelection]="
                                                                true
                                                            "
                                                            panelWidth="auto"
                                                            (optionSelected)="
                                                                onPartAutocompleteSelected(
                                                                    itemControl,
                                                                    $event
                                                                        .option
                                                                        .value
                                                                )
                                                            "
                                                        >
                                                            <!-- Sentinel option (value 0) shown only when typed text doesn't match any existing part. -->
                                                            @if (newPartName) {
                                                            <mat-option
                                                                [value]="0"
                                                                >{{
                                                                    newPartName
                                                                }}
                                                                (Create
                                                                New)...</mat-option
                                                            >
                                                            } @for (part of
                                                            filteredParts; track
                                                            part) {
                                                            <!--
                                                                            Autocomplete option per part-revision. Label
                                                                            shows "{number} Rev {N}" for parts with multiple
                                                                            sisters; bare number otherwise. Verified rev
                                                                            gets a green check next to the label. Mirror of
                                                                            bom-builder's option.
                                                                            -->
                                                            <!-- Two-row option layout — top: label + icons (nowrap),
                                                                            bottom: description. Keeps Rev N fully visible
                                                                            regardless of panel width. Mirror of bom-builder. -->
                                                            @if
                                                            (showPartOption(part,
                                                            itemControl)) {
                                                            <mat-option
                                                                [value]="
                                                                    part.id
                                                                "
                                                                style="
                                                                    height: auto;
                                                                    line-height: 1.2;
                                                                    padding-top: 0.5rem;
                                                                    padding-bottom: 0.5rem;
                                                                "
                                                            >
                                                                <div
                                                                    class="flex gap-1 items-center"
                                                                    style="
                                                                        white-space: nowrap;
                                                                    "
                                                                >
                                                                    <span
                                                                        class="font-medium"
                                                                        >{{
                                                                            formatPartLabel(
                                                                                part
                                                                            )
                                                                        }}</span
                                                                    >
                                                                    @if
                                                                    (part.isVerifiedVersion
                                                                    &&
                                                                    part.partVersionsId
                                                                    &&
                                                                    part.sisterParts?.length
                                                                    > 1) {
                                                                    <mat-icon
                                                                        [matTooltip]="
                                                                            'Verified revision'
                                                                        "
                                                                        [style.color]="
                                                                            '#12df12'
                                                                        "
                                                                        class="icon-size-3 m-0"
                                                                        svgIcon="mat_solid:verified"
                                                                    ></mat-icon>
                                                                    } @if
                                                                    (part.isHighRisk)
                                                                    {
                                                                    <mat-icon
                                                                        [matTooltip]="
                                                                            'High Risk'
                                                                        "
                                                                        color="warn"
                                                                        class="icon-size-4 m-0"
                                                                        svgIcon="mat_solid:warning"
                                                                    ></mat-icon>
                                                                    } @if
                                                                    (part.isCritical)
                                                                    {
                                                                    <mat-icon
                                                                        [matTooltip]="
                                                                            'Critical Component'
                                                                        "
                                                                        color="warn"
                                                                        class="icon-size-4 m-0"
                                                                        svgIcon="mat_solid:flag"
                                                                    ></mat-icon>
                                                                    } @if
                                                                    (part.currentStock
                                                                    <
                                                                    part.minimumStock)
                                                                    {
                                                                    <mat-icon
                                                                        [matTooltip]="
                                                                            'Stock under Minimum'
                                                                        "
                                                                        color="warn"
                                                                        class="icon-size-5"
                                                                        svgIcon="mat_solid:remove_shopping_cart"
                                                                    ></mat-icon>
                                                                    }
                                                                </div>
                                                                <div
                                                                    class="text-xs text-secondary leading-tight"
                                                                >
                                                                    {{
                                                                        part.description
                                                                    }}
                                                                </div>
                                                            </mat-option>
                                                            } }
                                                        </mat-autocomplete>
                                                        <mat-icon
                                                            matSuffix
                                                            class="text-[#0000008a] mr-[-0.4rem] cursor-pointer"
                                                            >arrow_drop_down</mat-icon
                                                        >
                                                    </mat-form-field>
                                                </div>
                                                <span
                                                    class="rounded-full px-2 w-min text-sm whitespace-pre"
                                                    [class.bg-gray-50]="
                                                        !isAssemblyType(
                                                            itemControl
                                                        )
                                                    "
                                                    [class.bg-blue-100]="
                                                        isAssemblyType(
                                                            itemControl
                                                        )
                                                    "
                                                >
                                                    {{
                                                        getComponentType(
                                                            itemControl
                                                        ) | uppercase
                                                    }}
                                                </span>
                                                <mat-form-field
                                                    class="fuse-mat-dense"
                                                    subscriptSizing="dynamic"
                                                    [matTooltip]="
                                                        'Default sourcing for this line.'
                                                    "
                                                >
                                                    <mat-select
                                                        formControlName="sourceType"
                                                    >
                                                        <mat-option
                                                            [value]="null"
                                                            ><span
                                                                class="text-secondary"
                                                                >Not set</span
                                                            ></mat-option
                                                        >
                                                        <mat-option
                                                            [value]="
                                                                ComponentSourceType.InStock
                                                            "
                                                            >Stock</mat-option
                                                        >
                                                        <mat-option
                                                            [value]="
                                                                ComponentSourceType.Production
                                                            "
                                                            >In-House</mat-option
                                                        >
                                                        <mat-option
                                                            [value]="
                                                                ComponentSourceType.ThirdParty
                                                            "
                                                            >Third
                                                            Party</mat-option
                                                        >
                                                    </mat-select>
                                                </mat-form-field>
                                                <mat-form-field
                                                    class="fuse-mat-dense"
                                                    subscriptSizing="dynamic"
                                                >
                                                    <input
                                                        matInput
                                                        type="number"
                                                        step="1"
                                                        min="1"
                                                        formControlName="quantity"
                                                        (change)="
                                                            productsForm?.valid &&
                                                                save(
                                                                    true,
                                                                    false,
                                                                    deal?.isWizardInFirstStage
                                                                );
                                                            checkLineStock(
                                                                itemControl
                                                            )
                                                        "
                                                    />
                                                </mat-form-field>
                                                <!--
                                                                      Unit cell: read-only label for established parts;
                                                                      editable dropdown for parts created via the
                                                                      inline "Create New" flow in this dialog session.
                                                                      Persists via apiPartPartPut. Mirror of the
                                                                      bom-builder unit cell.
                                                                      -->
                                                @if
                                                (!isNewlyCreatedPart(itemControl))
                                                {
                                                <span>{{
                                                    partUnitTypeName(
                                                        lookupPart(itemControl)
                                                            ?.partUnitType ?? 0
                                                    )
                                                }}</span>
                                                } @if
                                                (isNewlyCreatedPart(itemControl))
                                                {
                                                <mat-form-field
                                                    class="fuse-mat-dense"
                                                    subscriptSizing="dynamic"
                                                >
                                                    <mat-select
                                                        [value]="
                                                            lookupPart(
                                                                itemControl
                                                            )?.partUnitType ?? 0
                                                        "
                                                        (selectionChange)="
                                                            changePartUnitType(
                                                                itemControl,
                                                                $event.value
                                                            )
                                                        "
                                                    >
                                                        <mat-option
                                                            [value]="
                                                                PartUnitType.EA
                                                            "
                                                            >EA</mat-option
                                                        >
                                                        <mat-option
                                                            [value]="
                                                                PartUnitType.Pack
                                                            "
                                                            >Pack</mat-option
                                                        >
                                                        <mat-option
                                                            [value]="
                                                                PartUnitType.M
                                                            "
                                                            >M</mat-option
                                                        >
                                                        <mat-option
                                                            [value]="
                                                                PartUnitType.Mm
                                                            "
                                                            >mm</mat-option
                                                        >
                                                    </mat-select>
                                                </mat-form-field>
                                                }
                                                <!-- <span>{{lookupPart(itemControl)?.cost | currency:'GBP'}}</span> -->
                                                <mat-form-field
                                                    class="fuse-mat-dense w-full"
                                                    subscriptSizing="dynamic"
                                                    [ngClass]="{
                                                        'outline outline-2 outline-red-500 rounded':
                                                            isZeroCost(
                                                                itemControl
                                                            )
                                                    }"
                                                >
                                                    <input
                                                        matInput
                                                        formControlName="cost"
                                                        type="number"
                                                        step="0.1"
                                                        min="0"
                                                        (change)="
                                                            productsForm?.valid &&
                                                                save(
                                                                    true,
                                                                    false,
                                                                    deal?.isWizardInFirstStage
                                                                )
                                                        "
                                                    />
                                                    <span matPrefix>£</span>
                                                </mat-form-field>
                                                <span
                                                    [ngClass]="{
                                                        'outline outline-2 outline-red-500 rounded px-1':
                                                            isZeroCost(
                                                                itemControl
                                                            )
                                                    }"
                                                    >{{
                                                        getItemRolledUpTotal(
                                                            itemControl
                                                        ) | currency: "GBP"
                                                    }}</span
                                                >
                                                <div
                                                    class="flex gap-2 items-center"
                                                >
                                                    @if
                                                    (lookupPart(itemControl)) {
                                                    <div
                                                        class="h-2 w-2 rounded-full bg-orange-500"
                                                    ></div>
                                                    <span
                                                        >{{
                                                            lookupPart(
                                                                itemControl
                                                            )?.currentStock
                                                        }}
                                                        in stock</span
                                                    >
                                                    }
                                                </div>
                                                <div
                                                    class="text-right col-span-2 flex justify-end gap-1"
                                                >
                                                    <!-- Substitute Parts -->
                                                    <button
                                                        mat-icon-button
                                                        [disabled]="
                                                            !getSubstitutes(
                                                                itemControl
                                                            )?.length
                                                        "
                                                        [matMenuTriggerFor]="
                                                            substitutesMenu
                                                        "
                                                        [matTooltip]="
                                                            'Substitute Parts'
                                                        "
                                                    >
                                                        <mat-icon
                                                            class="icon-size-4"
                                                            [svgIcon]="
                                                                'custom:compare'
                                                            "
                                                        ></mat-icon>
                                                    </button>
                                                    <mat-menu
                                                        class="max-h-72"
                                                        #substitutesMenu="matMenu"
                                                        [xPosition]="'before'"
                                                    >
                                                        <div class="px-4">
                                                            Switch to Substitute
                                                            Part:
                                                        </div>
                                                        <div
                                                            class="flex flex-col"
                                                        >
                                                            @for (part of
                                                            getSubstitutes(itemControl);
                                                            track part) {
                                                            <div
                                                                class="w-full border-b my-1"
                                                            ></div>
                                                            <button
                                                                mat-menu-item
                                                                (click)="
                                                                    selectSubstitute(
                                                                        itemControl,
                                                                        part
                                                                    )
                                                                "
                                                            >
                                                                <div
                                                                    class="flex flex-col"
                                                                >
                                                                    <div
                                                                        class="flex justify-between gap-2 items-center"
                                                                    >
                                                                        <div
                                                                            class="flex gap-1 items-center"
                                                                        >
                                                                            <span
                                                                                >{{
                                                                                    part.number
                                                                                }}</span
                                                                            >
                                                                            @if
                                                                            (part.isHighRisk)
                                                                            {
                                                                            <mat-icon
                                                                                [matTooltip]="
                                                                                    'High Risk'
                                                                                "
                                                                                color="warn"
                                                                                class="icon-size-4 m-0"
                                                                                svgIcon="mat_solid:warning"
                                                                            ></mat-icon>
                                                                            }
                                                                            @if
                                                                            (part.isCritical)
                                                                            {
                                                                            <mat-icon
                                                                                [matTooltip]="
                                                                                    'Critical Component'
                                                                                "
                                                                                color="warn"
                                                                                class="icon-size-4 m-0"
                                                                                svgIcon="mat_solid:flag"
                                                                            ></mat-icon>
                                                                            }
                                                                            @if
                                                                            (part.currentStock
                                                                            <
                                                                            part.minimumStock)
                                                                            {
                                                                            <mat-icon
                                                                                [matTooltip]="
                                                                                    'Stock under Minimum'
                                                                                "
                                                                                color="warn"
                                                                                class="icon-size-5"
                                                                                svgIcon="mat_solid:remove_shopping_cart"
                                                                            ></mat-icon>
                                                                            }
                                                                        </div>
                                                                        @if
                                                                        (isCheapestSubstitute(itemControl,
                                                                        part)) {
                                                                        <span
                                                                            class="text-sm text-green-500"
                                                                            >cheapest</span
                                                                        >
                                                                        }
                                                                    </div>
                                                                    <div
                                                                        class="text-sm leading-none"
                                                                    >
                                                                        {{
                                                                            part.description
                                                                        }}
                                                                    </div>
                                                                    <div
                                                                        class="text-sm"
                                                                    >
                                                                        Cost:
                                                                        {{
                                                                            part.cost
                                                                                | currency
                                                                                    : "GBP"
                                                                        }}
                                                                        | Stock:
                                                                        {{
                                                                            part.currentStock
                                                                        }}
                                                                    </div>
                                                                </div>
                                                            </button>
                                                            }
                                                        </div>
                                                    </mat-menu>
                                                    <!-- Drawings Download -->
                                                    <button
                                                        mat-icon-button
                                                        [disabled]="
                                                            !getFilesForPart(
                                                                itemControl
                                                            )?.length
                                                        "
                                                        [matMenuTriggerFor]="
                                                            drawingsMenu
                                                        "
                                                        [matTooltip]="
                                                            'Drawings'
                                                        "
                                                    >
                                                        <mat-icon
                                                            class="icon-size-4"
                                                            [svgIcon]="
                                                                'mat_outline:attach_file'
                                                            "
                                                        ></mat-icon>
                                                    </button>
                                                    <mat-menu
                                                        class="max-h-72"
                                                        #drawingsMenu="matMenu"
                                                        [xPosition]="'before'"
                                                    >
                                                        <div class="px-4">
                                                            Download Drawings:
                                                        </div>
                                                        <div
                                                            class="flex flex-col"
                                                        >
                                                            @for (file of
                                                            getFilesForPart(itemControl);
                                                            track file) {
                                                            <div
                                                                class="w-full border-b my-1"
                                                            ></div>
                                                            <button
                                                                mat-menu-item
                                                                (click)="
                                                                    downloadPartFile(
                                                                        file
                                                                    )
                                                                "
                                                            >
                                                                <div
                                                                    class="flex justify-between gap-1 items-center w-full"
                                                                >
                                                                    <div
                                                                        class="inline-block relative text-center"
                                                                    >
                                                                        <mat-icon
                                                                            class="icon-size-8 text-hint opacity-50"
                                                                            [svgIcon]="
                                                                                'heroicons_solid:document'
                                                                            "
                                                                        ></mat-icon>
                                                                        <div
                                                                            class="absolute left-0 bottom-0 px-1.5 rounded text-xs font-semibold leading-4 text-white"
                                                                            [class.bg-red-600]="
                                                                                file.type ==
                                                                                '.pdf'
                                                                            "
                                                                            [class.bg-blue-600]="
                                                                                file.type ==
                                                                                '.doc'
                                                                            "
                                                                            [class.bg-green-600]="
                                                                                file.type ==
                                                                                '.xls'
                                                                            "
                                                                            [class.bg-gray-600]="
                                                                                file.type ==
                                                                                '.txt'
                                                                            "
                                                                            [class.bg-amber-600]="
                                                                                file.type ==
                                                                                '.jpg'
                                                                            "
                                                                            [class.bg-yellow-500]="
                                                                                file.type ==
                                                                                '.png'
                                                                            "
                                                                        >
                                                                            {{
                                                                                file.type.toUpperCase()
                                                                            }}
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        class="leading-snug min-w-0"
                                                                    >
                                                                        {{
                                                                            file.name
                                                                        }}
                                                                    </div>
                                                                    <div
                                                                        class="text-sm leading-none pl-1"
                                                                    >
                                                                        {{
                                                                            file.createdUTC
                                                                                | date
                                                                                    : "dd/MM/yy"
                                                                        }}
                                                                    </div>
                                                                </div>
                                                            </button>
                                                            }
                                                        </div>
                                                    </mat-menu>
                                                    <!-- Per-line Process Steps -->
                                                    <button
                                                        mat-icon-button
                                                        [disabled]="
                                                            !getLineKey(
                                                                itemControl
                                                            )
                                                        "
                                                        [matTooltip]="
                                                            !getLineKey(
                                                                itemControl
                                                            )
                                                                ? 'Pick a part first'
                                                                : isLineProcessesExpanded(
                                                                      getLineKey(
                                                                          itemControl
                                                                      )
                                                                  )
                                                                ? 'Hide Process Steps'
                                                                : 'Show/Add Process Steps'
                                                        "
                                                        [matBadge]="
                                                            getTotalProcessCountForItem(
                                                                itemControl
                                                            )
                                                        "
                                                        [matBadgeHidden]="
                                                            !getTotalProcessCountForItem(
                                                                itemControl
                                                            )
                                                        "
                                                        matBadgeSize="small"
                                                        matBadgeColor="primary"
                                                        (click)="
                                                            toggleLineProcesses(
                                                                getLineKey(
                                                                    itemControl
                                                                )
                                                            )
                                                        "
                                                    >
                                                        <mat-icon
                                                            class="icon-size-4"
                                                            [svgIcon]="
                                                                isLineProcessesExpanded(
                                                                    getLineKey(
                                                                        itemControl
                                                                    )
                                                                )
                                                                    ? 'heroicons_solid:queue-list'
                                                                    : 'heroicons_outline:queue-list'
                                                            "
                                                        ></mat-icon>
                                                    </button>
                                                    <button
                                                        mat-icon-button
                                                        (click)="
                                                            deletePartItem(i)
                                                        "
                                                        [matTooltip]="
                                                            'Delete Row'
                                                        "
                                                    >
                                                        <mat-icon
                                                            class="icon-size-4"
                                                            [svgIcon]="
                                                                'heroicons_solid:trash'
                                                            "
                                                        ></mat-icon>
                                                    </button>
                                                </div>
                                            </div>
                                            <!--
                                                                      Per-line process expansion panel. Three-sided border
                                                                      (L/R/B, no top) so the panel reads as a "cup" hanging
                                                                      off the parent row above (which is now tinted to
                                                                      match). Margin-left scales with the owning line's
                                                                      level depth so the panel indents to its parent's
                                                                      column. Border styles inlined with !important to
                                                                      beat the divide-y top border that the parent rows
                                                                      container imposes. Mirror of the BOM Builder's
                                                                      per-line panel restyle.
                                                                      -->
                                            @if
                                            (isLineProcessesExpanded(getLineKey(itemControl)))
                                            {
                                            <div
                                                class="col-span-4 px-5 py-3 mr-6 mb-4 bg-[#fafafa] rounded-b-md"
                                                [style]="
                                                    'margin-left: ' +
                                                    (getLevelIndent(
                                                        itemControl
                                                    ) *
                                                        1.2 +
                                                        1.5) +
                                                    'rem; border-top: 0 !important; border-left: 1px solid #d1d5db !important; border-right: 1px solid #d1d5db !important; border-bottom: 1px solid #d1d5db !important;'
                                                "
                                            >
                                                <!-- Linked sub-BOM badge — only shown when a sub-BOM exists for this part -->
                                                @if
                                                (getLinkedSubBomForItem(itemControl);
                                                as linkedBadge) {
                                                <div
                                                    class="mb-4 p-2 bg-blue-50 border border-blue-200 rounded flex items-center gap-2 text-sm text-blue-700"
                                                >
                                                    <mat-icon
                                                        class="icon-size-4"
                                                        svgIcon="heroicons_outline:link"
                                                    ></mat-icon>
                                                    <span
                                                        >Linked to reusable
                                                        sub-BOM (rev
                                                        {{
                                                            linkedBadge.revision
                                                        }})</span
                                                    >
                                                    @if
                                                    (!linkedBadge.isNotDraft) {
                                                    <span
                                                        class="text-xs px-2 py-0.5 rounded bg-amber-100 text-amber-700 font-medium"
                                                        >DRAFT</span
                                                    >
                                                    }
                                                </div>
                                                }
                                                <!--
                                                                          Section 1: read-only sub-BOM processes — breadcrumb-style
                                                                          header for visual consistency with the BOM Builder's
                                                                          nested panel.
                                                                          -->
                                                @if
                                                (getLinkedSubBomForItem(itemControl);
                                                as linkedSubBom) {
                                                <div
                                                    class="flex items-center justify-between mb-3"
                                                >
                                                    <h4
                                                        class="flex items-center gap-2 text-sm uppercase tracking-wide text-secondary"
                                                    >
                                                        <mat-icon
                                                            class="icon-size-4 text-blue-600"
                                                            svgIcon="heroicons_outline:cube"
                                                        ></mat-icon>
                                                        <span
                                                            >Manufacturing
                                                            Process</span
                                                        >
                                                        <span
                                                            class="text-gray-400"
                                                            >/</span
                                                        >
                                                        <span
                                                            class="text-secondary normal-case"
                                                            >{{
                                                                lookupPart(
                                                                    itemControl
                                                                )?.number
                                                            }}</span
                                                        >
                                                        <span
                                                            class="text-xs text-secondary font-normal normal-case"
                                                            >(from sub-BOM rev
                                                            {{
                                                                linkedSubBom.revision
                                                            }}{{
                                                                linkedSubBom.isPhantom
                                                                    ? ", phantom"
                                                                    : ""
                                                            }})</span
                                                        >
                                                        @if
                                                        (!linkedSubBom.isNotDraft)
                                                        {
                                                        <span
                                                            class="text-xs px-2 py-0.5 rounded bg-amber-100 text-amber-700 font-medium normal-case"
                                                            >DRAFT</span
                                                        >
                                                        }
                                                    </h4>
                                                    <button
                                                        mat-stroked-button
                                                        (click)="
                                                            openSubBomInNewTab(
                                                                linkedSubBom.bomId
                                                            )
                                                        "
                                                        [matTooltip]="
                                                            'Edit in new tab'
                                                        "
                                                    >
                                                        <mat-icon
                                                            class="icon-size-4 mr-1"
                                                            svgIcon="heroicons_outline:arrow-top-right-on-square"
                                                        ></mat-icon>
                                                        Edit sub-BOM
                                                    </button>
                                                </div>
                                                @if
                                                (getLinkedSubBomProcesses(itemControl)?.length)
                                                {
                                                <div
                                                    class="flex flex-col divide-y border rounded-lg overflow-hidden bg-blue-50/40 mb-4"
                                                >
                                                    <div
                                                        class="grid grid-cols-13 bg-blue-100/60 py-2 px-4 gap-3 items-center uppercase text-sm tracking-tight"
                                                    >
                                                        <span>Seq</span>
                                                        <span>Op Code</span>
                                                        <span class="col-span-3"
                                                            >Operation
                                                            Name</span
                                                        >
                                                        <span class="col-span-2"
                                                            >Source</span
                                                        >
                                                        <span class="col-span-2"
                                                            >Cost Centre</span
                                                        >
                                                        <span>Setup</span>
                                                        <span>Run</span>
                                                        <span
                                                            class="col-span-2 text-right text-secondary"
                                                            >Read-only</span
                                                        >
                                                    </div>
                                                    @for (process of
                                                    getLinkedSubBomProcesses(itemControl);
                                                    track process) {
                                                    <div
                                                        class="grid grid-cols-13 py-2 px-4 gap-3 items-center text-md"
                                                    >
                                                        <span>{{
                                                            process.sequence
                                                        }}</span>
                                                        <span>{{
                                                            process.operationCode
                                                        }}</span>
                                                        <div class="col-span-3">
                                                            <div>
                                                                {{
                                                                    process.operationName
                                                                }}
                                                            </div>
                                                            @if
                                                            (process.isSubcontracted)
                                                            {
                                                            <div
                                                                class="text-xs text-orange-500 flex items-center gap-1"
                                                            >
                                                                <mat-icon
                                                                    class="icon-size-3"
                                                                    >business</mat-icon
                                                                >
                                                                {{
                                                                    process.subcontractorName
                                                                }}
                                                            </div>
                                                            }
                                                        </div>
                                                        <span
                                                            class="col-span-2 text-xs"
                                                        >
                                                            @if
                                                            (process.sourceType
                                                            ===
                                                            ComponentSourceType.InStock)
                                                            {
                                                            <span
                                                                class="inline-flex items-center gap-1 px-2 py-0.5 rounded bg-gray-100 text-gray-700"
                                                            >
                                                                <mat-icon
                                                                    class="icon-size-3"
                                                                    svgIcon="heroicons_outline:archive-box"
                                                                ></mat-icon
                                                                >Stock
                                                            </span>
                                                            } @if
                                                            (process.sourceType
                                                            ===
                                                            ComponentSourceType.Production)
                                                            {
                                                            <span
                                                                class="inline-flex items-center gap-1 px-2 py-0.5 rounded bg-blue-100 text-blue-700"
                                                            >
                                                                <mat-icon
                                                                    class="icon-size-3"
                                                                    svgIcon="heroicons_outline:cog-6-tooth"
                                                                ></mat-icon
                                                                >In-House
                                                            </span>
                                                            } @if
                                                            (process.sourceType
                                                            ===
                                                            ComponentSourceType.ThirdParty)
                                                            {
                                                            <span
                                                                class="inline-flex items-center gap-1 px-2 py-0.5 rounded bg-orange-100 text-orange-700"
                                                            >
                                                                <mat-icon
                                                                    class="icon-size-3"
                                                                    svgIcon="heroicons_outline:building-office"
                                                                ></mat-icon
                                                                >Third Party
                                                            </span>
                                                            } @if
                                                            (process.sourceType
                                                            == null) {
                                                            <span
                                                                class="text-secondary"
                                                                >-</span
                                                            >
                                                            }
                                                        </span>
                                                        <span
                                                            class="col-span-2"
                                                            >{{
                                                                getCostCentreName(
                                                                    process.costCenterCode
                                                                )
                                                            }}</span
                                                        >
                                                        <span>{{
                                                            getHoursText(
                                                                process.setupHours *
                                                                    (process.isSubcontracted
                                                                        ? SUBCONTRACT_SETUP_WEEK_TO_HOURS
                                                                        : 1)
                                                            )
                                                        }}</span>
                                                        <span>{{
                                                            getHoursText(
                                                                process.runPerUnitHours
                                                            )
                                                        }}</span>
                                                        <span
                                                            class="col-span-2 text-right text-xs text-secondary italic"
                                                            >Edit in
                                                            sub-BOM</span
                                                        >
                                                    </div>
                                                    }
                                                </div>
                                                } @else {
                                                <div
                                                    class="border border-dashed rounded p-3 text-center text-secondary text-sm mb-4"
                                                >
                                                    This sub-BOM currently has
                                                    no manufacturing process
                                                    steps.
                                                </div>
                                                } }
                                                <!--
                                                                          Section 2: editable per-line steps owned by this quote line.
                                                                          Breadcrumb-style header (uppercase + slash separator) matching
                                                                          the BOM Builder restyle.
                                                                          -->
                                                <div
                                                    class="flex items-center justify-between mb-3"
                                                >
                                                    <h4
                                                        class="flex items-center gap-2 text-sm uppercase tracking-wide text-secondary"
                                                    >
                                                        <mat-icon
                                                            class="icon-size-4"
                                                            svgIcon="heroicons_outline:queue-list"
                                                        ></mat-icon>
                                                        @if
                                                        (getLinkedSubBomForItem(itemControl))
                                                        {
                                                        <span
                                                            >Integration
                                                            Steps</span
                                                        >
                                                        <span
                                                            class="text-gray-400"
                                                            >/</span
                                                        >
                                                        <span
                                                            class="text-secondary normal-case"
                                                            >{{
                                                                lookupPart(
                                                                    itemControl
                                                                )?.number
                                                            }}
                                                            on this quote</span
                                                        >
                                                        } @else {
                                                        <span
                                                            >Assembly
                                                            Process</span
                                                        >
                                                        <span
                                                            class="text-gray-400"
                                                            >/</span
                                                        >
                                                        <span
                                                            class="text-secondary normal-case"
                                                            >{{
                                                                lookupPart(
                                                                    itemControl
                                                                )?.number
                                                            }}</span
                                                        >
                                                        }
                                                    </h4>
                                                    <button
                                                        mat-stroked-button
                                                        color="primary"
                                                        (click)="
                                                            openAssemblyProcessPopup(
                                                                {
                                                                    bomItemId:
                                                                        itemControl.get(
                                                                            'bomItemId'
                                                                        )
                                                                            ?.value,
                                                                    clientLineId:
                                                                        itemControl.get(
                                                                            'clientLineId'
                                                                        )?.value
                                                                },
                                                                true
                                                            )
                                                        "
                                                    >
                                                        <mat-icon
                                                            class="icon-size-4 mr-1"
                                                            svgIcon="heroicons_outline:plus-circle"
                                                        ></mat-icon>
                                                        Add Step
                                                    </button>
                                                </div>
                                                @if
                                                (getProcessesForItem(getLineKey(itemControl))?.length)
                                                {
                                                <div
                                                    class="flex flex-col divide-y border rounded-lg overflow-hidden bg-white"
                                                >
                                                    <div
                                                        class="grid grid-cols-13 bg-gray-50 py-2 px-4 gap-3 items-center uppercase text-sm tracking-tight"
                                                    >
                                                        <span>Seq</span>
                                                        <span>Op Code</span>
                                                        <span class="col-span-3"
                                                            >Operation
                                                            Name</span
                                                        >
                                                        <span class="col-span-2"
                                                            >Source</span
                                                        >
                                                        <span class="col-span-2"
                                                            >Cost Centre</span
                                                        >
                                                        <span>Setup</span>
                                                        <span>Run</span>
                                                        <span
                                                            class="col-span-2 text-right"
                                                            >Actions</span
                                                        >
                                                    </div>
                                                    @for (process of
                                                    getProcessesForItem(getLineKey(itemControl));
                                                    track process) {
                                                    <div
                                                        class="grid grid-cols-13 py-2 px-4 gap-3 items-center text-md"
                                                    >
                                                        <span>{{
                                                            process.sequence
                                                        }}</span>
                                                        <span>{{
                                                            process.operationCode
                                                        }}</span>
                                                        <div class="col-span-3">
                                                            <div>
                                                                {{
                                                                    process.operationName
                                                                }}
                                                            </div>
                                                            @if
                                                            (process.isSubcontracted)
                                                            {
                                                            <div
                                                                class="text-xs text-orange-500 flex items-center gap-1"
                                                            >
                                                                <mat-icon
                                                                    class="icon-size-3"
                                                                    >business</mat-icon
                                                                >
                                                                {{
                                                                    process.subcontractorName
                                                                }}
                                                            </div>
                                                            }
                                                        </div>
                                                        <span
                                                            class="col-span-2 text-xs"
                                                        >
                                                            @if
                                                            (process.sourceType
                                                            ===
                                                            ComponentSourceType.InStock)
                                                            {
                                                            <span
                                                                class="inline-flex items-center gap-1 px-2 py-0.5 rounded bg-gray-100 text-gray-700"
                                                            >
                                                                <mat-icon
                                                                    class="icon-size-3"
                                                                    svgIcon="heroicons_outline:archive-box"
                                                                ></mat-icon
                                                                >Stock
                                                            </span>
                                                            } @if
                                                            (process.sourceType
                                                            ===
                                                            ComponentSourceType.Production)
                                                            {
                                                            <span
                                                                class="inline-flex items-center gap-1 px-2 py-0.5 rounded bg-blue-100 text-blue-700"
                                                            >
                                                                <mat-icon
                                                                    class="icon-size-3"
                                                                    svgIcon="heroicons_outline:cog-6-tooth"
                                                                ></mat-icon
                                                                >In-House
                                                            </span>
                                                            } @if
                                                            (process.sourceType
                                                            ===
                                                            ComponentSourceType.ThirdParty)
                                                            {
                                                            <span
                                                                class="inline-flex items-center gap-1 px-2 py-0.5 rounded bg-orange-100 text-orange-700"
                                                            >
                                                                <mat-icon
                                                                    class="icon-size-3"
                                                                    svgIcon="heroicons_outline:building-office"
                                                                ></mat-icon
                                                                >Third Party
                                                            </span>
                                                            } @if
                                                            (process.sourceType
                                                            == null) {
                                                            <span
                                                                class="text-secondary"
                                                                >-</span
                                                            >
                                                            }
                                                        </span>
                                                        <span
                                                            class="col-span-2"
                                                            >{{
                                                                getCostCentreName(
                                                                    process.costCentreCode
                                                                )
                                                            }}</span
                                                        >
                                                        <span>{{
                                                            getHoursText(
                                                                process.setupHours *
                                                                    (process.isSubcontracted
                                                                        ? SUBCONTRACT_SETUP_WEEK_TO_HOURS
                                                                        : 1)
                                                            )
                                                        }}</span>
                                                        <span>{{
                                                            getHoursText(
                                                                process.runPerUnitHours
                                                            )
                                                        }}</span>
                                                        <div
                                                            class="col-span-2 text-right"
                                                        >
                                                            <button
                                                                mat-icon-button
                                                                (click)="
                                                                    openAssemblyProcessPopup(
                                                                        process,
                                                                        false
                                                                    )
                                                                "
                                                            >
                                                                <mat-icon
                                                                    class="icon-size-4"
                                                                    svgIcon="heroicons_solid:pencil"
                                                                ></mat-icon>
                                                            </button>
                                                            <button
                                                                mat-icon-button
                                                                (click)="
                                                                    deleteAssemblyProcess(
                                                                        bomAssemblyProcesses.indexOf(
                                                                            process
                                                                        )
                                                                    )
                                                                "
                                                            >
                                                                <mat-icon
                                                                    class="icon-size-4"
                                                                    svgIcon="heroicons_solid:trash"
                                                                ></mat-icon>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    }
                                                </div>
                                                } @else {
                                                <div
                                                    class="border border-dashed border-2 rounded p-4 text-center text-secondary cursor-pointer hover:border-primary"
                                                    (click)="
                                                        openAssemblyProcessPopup(
                                                            {
                                                                bomItemId:
                                                                    itemControl.get(
                                                                        'bomItemId'
                                                                    )?.value,
                                                                clientLineId:
                                                                    itemControl.get(
                                                                        'clientLineId'
                                                                    )?.value
                                                            },
                                                            true
                                                        )
                                                    "
                                                >
                                                    + Click to add process step
                                                    for this sub-assembly
                                                </div>
                                                }
                                            </div>
                                            }
                                            <!-- <div class="border rounded-md p-3 flex gap-2 items-center">
                                                                      <div class="flex-auto">
                                                                        <div class="flex gap-4 mb-1 items-center">
                                                                          <div>{{lookupPart(itemControl)?.number}}</div>
                                                                          <div class="bg-[#f8f8f8] py-1 px-2 rounded-md text-sm">{{lookupPart(itemControl)?.currentStock}} in stock</div>
                                                                        </div>
                                                                        <div class="text-md">{{lookupPart(itemControl)?.description}}</div>
                                                                      </div>
                                                                      <div>
                                                                        <mat-form-field class="fuse-mat-dense" subscriptSizing="dynamic">
                                                                          <mat-label>Qty</mat-label>
                                                                          <input matInput type="number" [formControlName]="'quantity'">
                                                                        </mat-form-field>
                                                                      </div>
                                                                      <div class="mt-auto">
                                                                        <button mat-icon-button (click)="deletePartItem(i)">
                                                                          <mat-icon svgIcon="heroicons_outline:x-mark" class="icon-size-5"></mat-icon>
                                                                        </button>
                                                                      </div>
                                                                    </div> -->
                                        </ng-container>
                                        }
                                    </div>
                                    <!-- Add -->
                                    <div
                                        class="col-span-4 -mt-2 text-center justify-center items-center border border-dashed border-2 p-3 hover:border-primary cursor-pointer"
                                        (click)="addPartItem()"
                                    >
                                        + Click to add another component
                                    </div>
                                </ng-container>
                                }
                                <!-- Empty -->
                                @if ( ((getDealType() == DealType.Standard ||
                                getDealType() == DealType.RepeatCustom) &&
                                !productItems?.controls.length) ||
                                (isCustomQuote() && !partItems?.controls.length)
                                || (getDealType() == DealType.Calibration &&
                                !calibrationItems?.controls.length) ||
                                (getDealType() == DealType.Hire &&
                                !hireItems?.controls.length) || (getDealType()
                                == DealType.Marine &&
                                !marineItems?.controls.length) ) {
                                <div class="my-4 italic text-center text-hint">
                                    No
                                    {{
                                        isCustomQuote()
                                            ? "parts"
                                            : getDealType() ==
                                              DealType.Calibration
                                            ? "loadcells"
                                            : getDealType() == DealType.Hire
                                            ? "assets"
                                            : getDealType() == DealType.Marine
                                            ? "items"
                                            : "products"
                                    }}
                                    added yet.
                                </div>
                                } @if (isCustomQuote()) {
                                <div
                                    class="grid grid-cols-4 gap-x-8 gap-y-4 w-full relative px-8"
                                >
                                    <!-- Divider -->
                                    <div
                                        class="col-span-4 mt-2 border-t -mx-8"
                                    ></div>
                                    <!-- Assembly-level process steps — applies to the whole quote, in addition to per-line steps above. -->
                                    <div
                                        class="col-span-4 flex items-center justify-between"
                                    >
                                        <h3 class="text-xl">
                                            Assembly-Level Process Steps
                                            <span
                                                class="text-sm text-secondary font-normal ml-2"
                                                >(applies to the whole
                                                quote)</span
                                            >
                                        </h3>
                                        <button
                                            mat-stroked-button
                                            color="primary"
                                            type="button"
                                            [matTooltip]="
                                                'Copy steps from a Production manufacture process (Category > Process > Column)'
                                            "
                                            (click)="
                                                openImportManufactureProcessDialog()
                                            "
                                        >
                                            <mat-icon
                                                class="icon-size-4 mr-1"
                                                svgIcon="heroicons_outline:arrow-down-on-square"
                                            ></mat-icon>
                                            Import from Manufacturing Process
                                        </button>
                                    </div>
                                    <div
                                        class="col-span-4 flex flex-col divide-y -mx-8"
                                    >
                                        <!-- Header -->
                                        <div
                                            class="grid grid-cols-[repeat(12,minmax(0,1fr))] bg-gray-50 border-t py-2 gap-3 items-center uppercase text-md tracking-tight"
                                            style="
                                                padding-left: 3rem;
                                                padding-right: 1.5rem;
                                            "
                                        >
                                            <span>Seq</span>
                                            <span>Op Code</span>
                                            <span class="col-span-2"
                                                >Operation Name</span
                                            >
                                            <span class="col-span-2">For</span>
                                            <span class="col-span-2"
                                                >Source</span
                                            >
                                            <span class="col-span-2"
                                                >Cost Centre</span
                                            >
                                            <span>Setup (hr)</span>
                                            <span>Run (hr)</span>
                                        </div>
                                        <!-- Rows — only assembly-level processes (per-line ones render under their line above). -->
                                        <div>
                                            @if
                                            (getAssemblyLevelProcesses()?.length)
                                            { @for (process of
                                            getAssemblyLevelProcesses(); track
                                            process; let i = $index) {
                                            <div
                                                class="grid grid-cols-[repeat(12,minmax(0,1fr))] py-2 gap-3 items-center relative"
                                                style="
                                                    padding-left: 3rem;
                                                    padding-right: 1.5rem;
                                                "
                                            >
                                                <span>{{
                                                    process.sequence
                                                }}</span>
                                                <span>{{
                                                    process.operationCode
                                                }}</span>
                                                <div class="col-span-2">
                                                    <div>
                                                        {{
                                                            process.operationName
                                                        }}
                                                    </div>
                                                    @if
                                                    (process.isSubcontracted) {
                                                    <div
                                                        class="text-xs text-orange-500 flex items-center gap-1"
                                                    >
                                                        <mat-icon
                                                            class="icon-size-3"
                                                            >business</mat-icon
                                                        >
                                                        {{
                                                            process.subcontractorName
                                                        }}
                                                    </div>
                                                    }
                                                </div>
                                                <span
                                                    class="col-span-2 text-sm"
                                                    [class.text-secondary]="
                                                        !process.bomItemId &&
                                                        !process.clientLineId
                                                    "
                                                    [class.font-medium]="
                                                        process.bomItemId ||
                                                        process.clientLineId
                                                    "
                                                >
                                                    {{
                                                        getBomItemDescriptor(
                                                            getProcessLineKey(
                                                                process
                                                            )
                                                        )
                                                    }}
                                                </span>
                                                <span
                                                    class="col-span-2 text-xs"
                                                >
                                                    @if (process.sourceType ===
                                                    ComponentSourceType.InStock)
                                                    {
                                                    <span
                                                        class="inline-flex items-center gap-1 px-2 py-0.5 rounded bg-gray-100 text-gray-700"
                                                    >
                                                        <mat-icon
                                                            class="icon-size-3"
                                                            [svgIcon]="
                                                                'heroicons_outline:archive-box'
                                                            "
                                                        ></mat-icon
                                                        >Stock
                                                    </span>
                                                    } @if (process.sourceType
                                                    ===
                                                    ComponentSourceType.Production)
                                                    {
                                                    <span
                                                        class="inline-flex items-center gap-1 px-2 py-0.5 rounded bg-blue-100 text-blue-700"
                                                    >
                                                        <mat-icon
                                                            class="icon-size-3"
                                                            [svgIcon]="
                                                                'heroicons_outline:cog-6-tooth'
                                                            "
                                                        ></mat-icon
                                                        >In-House
                                                    </span>
                                                    } @if (process.sourceType
                                                    ===
                                                    ComponentSourceType.ThirdParty)
                                                    {
                                                    <span
                                                        class="inline-flex items-center gap-1 px-2 py-0.5 rounded bg-orange-100 text-orange-700"
                                                    >
                                                        <mat-icon
                                                            class="icon-size-3"
                                                            [svgIcon]="
                                                                'heroicons_outline:building-office'
                                                            "
                                                        ></mat-icon
                                                        >Third Party
                                                    </span>
                                                    } @if (process.sourceType ==
                                                    null) {
                                                    <span class="text-secondary"
                                                        >-</span
                                                    >
                                                    }
                                                </span>
                                                <span class="col-span-2">{{
                                                    getCostCentreName(
                                                        process.costCentreCode
                                                    )
                                                }}</span>
                                                <span>{{
                                                    getHoursText(
                                                        process.setupHours *
                                                            (process.isSubcontracted
                                                                ? SUBCONTRACT_SETUP_WEEK_TO_HOURS
                                                                : 1)
                                                    )
                                                }}</span>
                                                <span>{{
                                                    getHoursText(
                                                        process.runPerUnitHours
                                                    )
                                                }}</span>
                                            </div>
                                            } }
                                        </div>
                                    </div>
                                    <!-- Add (assembly-level) -->
                                    <div
                                        class="col-span-4 -mt-4 -mx-8 text-center justify-center items-center border border-dashed border-2 p-3 hover:border-primary cursor-pointer"
                                        (click)="
                                            openAssemblyProcessPopup(
                                                {
                                                    bomItemId: null,
                                                    clientLineId: null
                                                },
                                                true
                                            )
                                        "
                                    >
                                        + Click to add assembly-level process
                                        step
                                    </div>
                                    <!-- Divider -->
                                    <div
                                        class="col-span-4 mt-2 border-t -mx-8"
                                    ></div>
                                    <h3 class="col-span-4 text-xl">
                                        Labour Quote
                                    </h3>
                                    <!-- Divider -->
                                    <div
                                        class="col-span-4 mb-2 border-t -mx-8"
                                    ></div>
                                    <!-- Engineers -->
                                    <div class="col-span-2">
                                        <h4 class="text-lg mb-3">
                                            Cost Centre
                                        </h4>
                                        <!--
                                                                Labour Quote rows grouped by cost centre. Multiple assembly
                                                                processes sharing the same costCentreCode roll up into ONE
                                                                line — total hours and total cost aggregated. Mirror of the
                                                                BOM Builder's grouped Labour Quote. Edits happen via the
                                                                assembly-process popup (per-line panel above); this panel
                                                                is read-only summary, hence no Actions column.
                                                                -->
                                        <div
                                            class="w-full flex flex-col rounded-xl border overflow-hidden"
                                        >
                                            <div
                                                class="grid grid-cols-5 bg-gray-50 py-2 px-6 gap-2 items-center uppercase text-md tracking-tight"
                                            >
                                                <span class="col-span-2"
                                                    >Cost Centre</span
                                                >
                                                <span>Hours</span>
                                                <span>Rate</span>
                                                <span>Total</span>
                                            </div>
                                            @if
                                            (getGroupedCostCentreProcesses()?.length)
                                            { @for (group of
                                            getGroupedCostCentreProcesses();
                                            track group.costCentreCode) {
                                            <div
                                                class="grid grid-cols-5 py-2 px-6 gap-2 items-center border-t"
                                            >
                                                <span class="col-span-2">{{
                                                    getCostCentreName(
                                                        group.costCentreCode
                                                    )
                                                }}</span>
                                                <span>{{
                                                    getHoursText(
                                                        group.totalHours
                                                    )
                                                }}</span>
                                                <span>{{
                                                    group.costCentreRate
                                                        | currency: "GBP"
                                                }}</span>
                                                <span>{{
                                                    group.totalCost
                                                        | currency: "GBP"
                                                }}</span>
                                            </div>
                                            } }
                                        </div>
                                        <div class="text-lg text-right mt-2">
                                            Subtotal:
                                            {{
                                                getCostCentreProcessesTotal()
                                                    | currency: "GBP"
                                            }}
                                        </div>
                                    </div>
                                    <!-- Contractors -->
                                    <div class="col-span-2">
                                        <h4 class="text-lg mb-3">
                                            Subcontractors
                                        </h4>
                                        <div
                                            class="w-full flex flex-col rounded-xl border overflow-hidden"
                                        >
                                            <!-- Header -->
                                            <div
                                                class="grid grid-cols-6 bg-gray-50 py-2 px-6 gap-2 items-center uppercase text-md tracking-tight"
                                            >
                                                <span class="col-span-2"
                                                    >Contractor</span
                                                >
                                                <span>Qty</span>
                                                <span>Rate</span>
                                                <span>Total</span>
                                                <span class="text-right"
                                                    >Actions</span
                                                >
                                            </div>
                                            <!-- Assembly Process Subcontractors -->
                                            @if
                                            (getSubcontractorProcesses()?.length)
                                            { @for (process of
                                            getSubcontractorProcesses(); track
                                            process; let i = $index) {
                                            <div
                                                class="grid grid-cols-6 py-2 px-6 gap-2 items-center border-t"
                                            >
                                                <span class="col-span-2">{{
                                                    process.subcontractorName
                                                }}</span>
                                                <span>{{
                                                    getHoursText(
                                                        (process.setupHours ||
                                                            0) *
                                                            (process.isSubcontracted
                                                                ? 35
                                                                : 1) +
                                                            (process.runPerUnitHours ||
                                                                0)
                                                    )
                                                }}</span>
                                                <span>{{
                                                    process.subcontractorHourlyRate
                                                        | currency: "GBP"
                                                }}</span>
                                                <span>{{
                                                    getSubcontractorProcessTotal(
                                                        process
                                                    ) | currency: "GBP"
                                                }}</span>
                                                <div class="text-right">
                                                    <button
                                                        mat-icon-button
                                                        (click)="
                                                            deleteAssemblyProcess(
                                                                getSubcontractorProcessIndex(
                                                                    process
                                                                )
                                                            )
                                                        "
                                                    >
                                                        <mat-icon
                                                            class="icon-size-4"
                                                            [svgIcon]="
                                                                'heroicons_solid:trash'
                                                            "
                                                        ></mat-icon>
                                                    </button>
                                                </div>
                                            </div>
                                            } }
                                        </div>
                                        <div class="text-lg text-right mt-2">
                                            Subtotal:
                                            {{
                                                getAssemblySubcontractorTotal()
                                                    | currency: "GBP"
                                            }}
                                        </div>
                                    </div>
                                    <!-- Divider -->
                                    <div
                                        class="col-span-4 my-4 border-t -mx-8"
                                    ></div>
                                    <!-- Actions/Totals -->
                                    <div
                                        class="col-span-4 flex items-center justify-end"
                                    >
                                        <div class="flex gap-12">
                                            <div>
                                                <div class="text-sm">
                                                    Materials
                                                </div>
                                                <div class="text-xl">
                                                    {{
                                                        getMaterialTotal()
                                                            | currency: "GBP"
                                                    }}
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-sm">
                                                    Labour
                                                </div>
                                                <div class="text-xl">
                                                    {{
                                                        getCostCentreProcessesTotal() +
                                                            getAssemblySubcontractorTotal()
                                                            | currency: "GBP"
                                                    }}
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-sm">
                                                    Consumables (5%)
                                                </div>
                                                <div class="text-xl">
                                                    {{
                                                        getGrandTotal() * 0.05
                                                            | currency: "GBP"
                                                    }}
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-sm">
                                                    Total Cost
                                                </div>
                                                <div
                                                    class="text-xl text-primary"
                                                >
                                                    {{
                                                        getGrandTotal() * 1.05
                                                            | currency: "GBP"
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Attachments -->
                                <div class="px-7 pt-4">
                                    <div
                                        class="border rounded-2xl p-5 flex flex-col gap-4 w-full bg-[#f8f8f8]"
                                    >
                                        <div class="text-xl">
                                            BOM Attachments
                                        </div>
                                        <div
                                            class="w-full flex flex-row flex-0 overflow-x-auto overflow-y-hidden"
                                            style="height: 102px"
                                        >
                                            <div>
                                                <!--class="-ml-2"-->
                                                <!-- Upload file -->
                                                <button
                                                    mat-icon-button
                                                    (click)="
                                                        openFileUpload(true)
                                                    "
                                                >
                                                    <mat-icon
                                                        class="icon-size-5"
                                                        [svgIcon]="
                                                            'heroicons_solid:paper-clip'
                                                        "
                                                    ></mat-icon>
                                                </button>
                                            </div>
                                            <!-- Files -->
                                            @if (fileInfos?.length > 0) { @for
                                            (file of fileInfos; track file) {
                                            @if (file.isBom) {
                                            <div
                                                class="file-container p-2 mx-1"
                                            >
                                                <!-- Icons -->
                                                <div
                                                    [class.cursor-pointer]="
                                                        dealId
                                                    "
                                                    class="relative text-center"
                                                    (click)="
                                                        dealId && download(file)
                                                    "
                                                >
                                                    <div
                                                        class="inline-block relative text-center"
                                                    >
                                                        <mat-icon
                                                            class="icon-size-14 text-hint opacity-50"
                                                            [svgIcon]="
                                                                'heroicons_solid:document'
                                                            "
                                                        ></mat-icon>
                                                        <div
                                                            class="absolute left-0 bottom-0 px-1.5 rounded text-sm font-semibold leading-5 text-white"
                                                            [class.bg-red-600]="
                                                                file.type ==
                                                                '.pdf'
                                                            "
                                                            [class.bg-blue-600]="
                                                                file.type ==
                                                                '.doc'
                                                            "
                                                            [class.bg-green-600]="
                                                                file.type ==
                                                                '.xls'
                                                            "
                                                            [class.bg-gray-600]="
                                                                file.type ==
                                                                '.txt'
                                                            "
                                                            [class.bg-amber-600]="
                                                                file.type ==
                                                                '.jpg'
                                                            "
                                                            [class.bg-yellow-500]="
                                                                file.type ==
                                                                '.png'
                                                            "
                                                        >
                                                            {{
                                                                file.type.toUpperCase()
                                                            }}
                                                        </div>
                                                        @if (!isBasic) {
                                                        <button
                                                            class="absolute"
                                                            (click)="
                                                                deleteFile(
                                                                    file,
                                                                    $event
                                                                )
                                                            "
                                                        >
                                                            <mat-icon
                                                                class="icon-size-2 text-red-600"
                                                                >close</mat-icon
                                                            >
                                                        </button>
                                                        }
                                                    </div>
                                                </div>
                                                <div
                                                    [class.cursor-pointer]="
                                                        dealId
                                                    "
                                                    class="file-name text-s text-center mt-1"
                                                    (click)="
                                                        dealId && download(file)
                                                    "
                                                >
                                                    {{ file.name }}
                                                </div>
                                            </div>
                                            } } }
                                        </div>
                                    </div>
                                </div>
                                }
                            </form>
                            }
                        </div>
                    </div>

                    <div class="flex flex-col gap-2">
                        @if (hasZeroCostLines()) {
                        <p class="text-red-600 text-sm text-right">
                            {{ getZeroCostLineCount() }} line(s) have £0 cost
                            (highlighted above). Set a price on each before
                            continuing.
                        </p>
                        }
                        <div class="flex justify-between gap-2">
                            <button
                                mat-stroked-button
                                matStepperPrevious
                                type="button"
                            >
                                Back
                            </button>
                            <!--
                                                      Save Progress (custom-quote only): persists the half-built BOM
                                                      without closing the dialog. Saves deal + product + BOM (incl.
                                                      assembly processes), keeps the technician on Step 2, and shows
                                                      a toast on success. Card stays orange because isWizardInFirstStage
                                                      is preserved. Disabled-condition is looser than Send to Sales on
                                                      purpose — only requires the customer side to be valid, since
                                                      "save where I'm at" is supposed to work mid-build.
                                                      -->
                            @if (isCustomQuote()) {
                            <button
                                class="ml-auto"
                                (click)="saveBomProgress()"
                                mat-stroked-button
                                type="button"
                                [disabled]="!customerForm?.valid"
                            >
                                Save Progress
                            </button>
                            } @if (isCustomQuote()) {
                            <button
                                (click)="sendToSales()"
                                mat-flat-button
                                type="button"
                                [color]="'primary'"
                                [disabled]="
                                    !productsForm?.valid || hasZeroCostLines()
                                "
                            >
                                Send to Sales
                            </button>
                            } @if (!isCustomQuote() || deal?.isSentToSales) {
                            <button
                                mat-flat-button
                                matStepperNext
                                type="button"
                                [color]="'primary'"
                                [disabled]="
                                    !productsForm?.valid || hasZeroCostLines()
                                "
                            >
                                Next
                            </button>
                            }
                            <!-- Edit-BOM mode only: saves the amended BOM as a new
                                 revision (Q1234 -> Q1234a). Lives on the Build Product
                                 step so the technician can save the revision as soon as
                                 the BOM is amended, without stepping through to Preview. -->
                            @if (editBomMode) {
                            <button
                                mat-stroked-button
                                color="primary"
                                (click)="saveBomRevision()"
                                type="button"
                                [disabled]="hasZeroCostLines()"
                            >
                                Save BOM Revision
                            </button>
                            }
                        </div>
                    </div>
                </div>
            </mat-step>

            <!-- Review Step -->
            <mat-step label="Review Summary" [stepControl]="summaryForm">
                <div class="w-full flex flex-col gap-4">
                    <div
                        class="border rounded-2xl p-5 flex flex-col gap-4 w-full bg-[#f8f8f8] mt-4"
                    >
                        <div class="text-xl">Selected Items</div>

                        <!-- Line Items -->
                        @if (productsForm) {
                        <form
                            [formGroup]="productsForm"
                            class="flex flex-col gap-4"
                        >
                            @if ((getDealType() == DealType.Standard ||
                            getDealType() == DealType.RepeatCustom) &&
                            productItems?.controls) {
                            <ng-container formArrayName="productLines">
                                @for (itemControl of productItems?.controls;
                                track itemControl; let i = $index) {
                                <ng-container [formGroupName]="i">
                                    <div
                                        class="border rounded-xl bg-white flex flex-col gap-4"
                                    >
                                        <div
                                            class="py-4 px-6 border-b flex gap-4 items-center"
                                        >
                                            <div>Line: {{ i + 1 }}</div>
                                            <div>
                                                Product ID:
                                                {{
                                                    lookupProduct(itemControl)
                                                        ?.partNumber
                                                        | productNumber
                                                }}
                                            </div>
                                            <div>Rev: 1</div>
                                            <div class="text-md">
                                                {{
                                                    lookupProduct(itemControl)
                                                        ?.description
                                                }}
                                            </div>
                                            <div
                                                class="ml-auto text-primary text-xl"
                                            >
                                                {{
                                                    itemControl.controls["cost"]
                                                        .value *
                                                        itemControl.controls[
                                                            "quantity"
                                                        ].value -
                                                        itemControl.controls[
                                                            "discount"
                                                        ].value
                                                        | currency: "GBP"
                                                }}
                                            </div>
                                        </div>
                                        <div class="text-lg px-6">
                                            Specification:
                                        </div>
                                        <ul
                                            class="px-6 list-disc list-outside ml-6 flex flex-col gap-2"
                                        >
                                            <li>
                                                Quotation for
                                                {{
                                                    lookupProduct(itemControl)
                                                        ?.description
                                                }}
                                            </li>
                                            <li>
                                                Product Code:
                                                {{
                                                    lookupProduct(itemControl)
                                                        ?.partNumber
                                                        | productNumber
                                                }}
                                            </li>
                                            <li>
                                                Manufactured to industrial
                                                standards
                                            </li>
                                            <li>
                                                Quality controlled and tested
                                                prior to dispatch
                                            </li>
                                            <li>
                                                Full technical documentation
                                                included
                                            </li>
                                            <li>
                                                Supplied with material
                                                certificates and test reports
                                            </li>
                                        </ul>
                                        <div
                                            class="flex gap-8 px-6 py-4 bg-[#f8f8f8] mx-4 mb-4 rounded-md"
                                        >
                                            <div>
                                                <div class="text-lg mb-1">
                                                    Quantity
                                                </div>
                                                <div>
                                                    {{
                                                        itemControl.controls[
                                                            "quantity"
                                                        ].value
                                                    }}
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">
                                                    U/M
                                                </div>
                                                <div>EA</div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">
                                                    Unit Price
                                                </div>
                                                <div>
                                                    {{
                                                        itemControl.controls[
                                                            "cost"
                                                        ].value
                                                            | currency: "GBP"
                                                    }}
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">
                                                    Discount
                                                </div>
                                                <div>
                                                    <mat-form-field
                                                        class="fuse-mat-dense"
                                                        subscriptSizing="dynamic"
                                                    >
                                                        <input
                                                            matInput
                                                            type="number"
                                                            [formControlName]="
                                                                'discount'
                                                            "
                                                            (change)="
                                                                productsForm?.valid &&
                                                                    save(
                                                                        true,
                                                                        false,
                                                                        deal?.isWizardInFirstStage
                                                                    )
                                                            "
                                                        />
                                                        <span matPrefix>£</span>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">
                                                    Discount %
                                                </div>
                                                <div>
                                                    <mat-form-field
                                                        class="fuse-mat-dense"
                                                        subscriptSizing="dynamic"
                                                    >
                                                        <input
                                                            matInput
                                                            type="number"
                                                            [value]="
                                                                getDiscountPercentage(
                                                                    itemControl
                                                                )
                                                            "
                                                            (change)="
                                                                updateDiscountFromPercentage(
                                                                    $event,
                                                                    itemControl
                                                                )
                                                            "
                                                        />
                                                        <span matSuffix>%</span>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">
                                                    Lead Time
                                                </div>
                                                <div>
                                                    <mat-form-field
                                                        class="fuse-mat-dense"
                                                        subscriptSizing="dynamic"
                                                    >
                                                        <input
                                                            matInput
                                                            [formControlName]="
                                                                'leadTime'
                                                            "
                                                            (change)="
                                                                productsForm?.valid &&
                                                                    save(
                                                                        true,
                                                                        false,
                                                                        deal?.isWizardInFirstStage
                                                                    )
                                                            "
                                                        />
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">
                                                    Lead Time Type
                                                </div>
                                                <div>
                                                    <mat-form-field
                                                        class="fuse-mat-dense"
                                                        subscriptSizing="dynamic"
                                                    >
                                                        <mat-select
                                                            [formControlName]="
                                                                'leadTimeType'
                                                            "
                                                            (selectionChange)="
                                                                productsForm?.valid &&
                                                                    save(
                                                                        true,
                                                                        false,
                                                                        deal?.isWizardInFirstStage
                                                                    )
                                                            "
                                                        >
                                                            @for (option of
                                                            leadTimeTypes; track
                                                            option) {
                                                            <mat-option
                                                                [value]="
                                                                    option.value
                                                                "
                                                                >{{
                                                                    option.name
                                                                }}</mat-option
                                                            >
                                                            }
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">
                                                    Total Price
                                                </div>
                                                <div
                                                    class="text-primary text-lg"
                                                >
                                                    {{
                                                        itemControl.controls[
                                                            "cost"
                                                        ].value *
                                                            itemControl
                                                                .controls[
                                                                "quantity"
                                                            ].value -
                                                            itemControl
                                                                .controls[
                                                                "discount"
                                                            ].value
                                                            | currency: "GBP"
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                                }
                            </ng-container>
                            } @if (getDealType() == DealType.Hire &&
                            hireItems?.controls) {
                            <ng-container formArrayName="hireLines">
                                @for (itemControl of hireItems?.controls; track
                                itemControl; let i = $index) {
                                <ng-container [formGroupName]="i">
                                    <div
                                        class="border rounded-xl bg-white flex flex-col gap-4"
                                    >
                                        <div
                                            class="py-4 px-6 border-b flex gap-4 items-center"
                                        >
                                            <div>Line: {{ i + 1 }}</div>
                                            <div>
                                                Asset ID:
                                                {{
                                                    lookupAsset(itemControl)
                                                        ?.serialNumber
                                                }}
                                            </div>
                                            <div>Rev: 1</div>
                                            <div class="text-md">
                                                {{
                                                    lookupAsset(itemControl)
                                                        ?.name
                                                }}
                                            </div>
                                            <div
                                                class="ml-auto text-primary text-xl"
                                            >
                                                {{
                                                    itemControl.controls["cost"]
                                                        .value *
                                                        getHireQuantity(
                                                            itemControl
                                                        ) -
                                                        itemControl.controls[
                                                            "discount"
                                                        ].value
                                                        | currency: "GBP"
                                                }}
                                            </div>
                                        </div>
                                        <div class="text-lg px-6">
                                            Specification:
                                        </div>
                                        <ul
                                            class="px-6 list-disc list-outside ml-6 flex flex-col gap-2"
                                        >
                                            <li>
                                                Quotation for
                                                {{
                                                    lookupAsset(itemControl)
                                                        ?.name
                                                }}
                                            </li>
                                            <li>
                                                Product Code:
                                                {{
                                                    lookupAsset(itemControl)
                                                        ?.serialNumber
                                                }}
                                            </li>
                                            <li>
                                                Manufactured to industrial
                                                standards
                                            </li>
                                            <li>
                                                Quality controlled and tested
                                                prior to dispatch
                                            </li>
                                            <li>
                                                Full technical documentation
                                                included
                                            </li>
                                            <li>
                                                Supplied with material
                                                certificates and test reports
                                            </li>
                                        </ul>
                                        <div
                                            class="flex gap-8 px-6 py-4 bg-[#f8f8f8] mx-4 mb-4 rounded-md"
                                        >
                                            <div>
                                                <div class="text-lg mb-1">
                                                    Quantity
                                                </div>
                                                <div>
                                                    {{
                                                        getHireQuantity(
                                                            itemControl
                                                        )
                                                    }}
                                                    days
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">
                                                    U/M
                                                </div>
                                                <div>EA</div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">
                                                    Unit Price
                                                </div>
                                                <div>
                                                    {{
                                                        itemControl.controls[
                                                            "cost"
                                                        ].value
                                                            | currency: "GBP"
                                                    }}
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">
                                                    Discount
                                                </div>
                                                <div>
                                                    <mat-form-field
                                                        class="fuse-mat-dense"
                                                        subscriptSizing="dynamic"
                                                    >
                                                        <input
                                                            matInput
                                                            type="number"
                                                            [formControlName]="
                                                                'discount'
                                                            "
                                                            (change)="
                                                                productsForm?.valid &&
                                                                    save(
                                                                        true,
                                                                        false,
                                                                        deal?.isWizardInFirstStage
                                                                    )
                                                            "
                                                        />
                                                        <span matPrefix>£</span>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">
                                                    Discount %
                                                </div>
                                                <div>
                                                    <mat-form-field
                                                        class="fuse-mat-dense"
                                                        subscriptSizing="dynamic"
                                                    >
                                                        <input
                                                            matInput
                                                            type="number"
                                                            [value]="
                                                                getDiscountPercentage(
                                                                    itemControl,
                                                                    true
                                                                )
                                                            "
                                                            (change)="
                                                                updateDiscountFromPercentage(
                                                                    $event,
                                                                    itemControl,
                                                                    true
                                                                )
                                                            "
                                                        />
                                                        <span matSuffix>%</span>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">
                                                    Lead Time
                                                </div>
                                                <div>
                                                    <mat-form-field
                                                        class="fuse-mat-dense"
                                                        subscriptSizing="dynamic"
                                                    >
                                                        <input
                                                            matInput
                                                            [formControlName]="
                                                                'leadTime'
                                                            "
                                                            (change)="
                                                                productsForm?.valid &&
                                                                    save(
                                                                        true,
                                                                        false,
                                                                        deal?.isWizardInFirstStage
                                                                    )
                                                            "
                                                        />
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">
                                                    Lead Time Type
                                                </div>
                                                <div>
                                                    <mat-form-field
                                                        class="fuse-mat-dense"
                                                        subscriptSizing="dynamic"
                                                    >
                                                        <mat-select
                                                            [formControlName]="
                                                                'leadTimeType'
                                                            "
                                                            (selectionChange)="
                                                                productsForm?.valid &&
                                                                    save(
                                                                        true,
                                                                        false,
                                                                        deal?.isWizardInFirstStage
                                                                    )
                                                            "
                                                        >
                                                            @for (option of
                                                            leadTimeTypes; track
                                                            option) {
                                                            <mat-option
                                                                [value]="
                                                                    option.value
                                                                "
                                                                >{{
                                                                    option.name
                                                                }}</mat-option
                                                            >
                                                            }
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">
                                                    Total Price
                                                </div>
                                                <div
                                                    class="text-primary text-lg"
                                                >
                                                    {{
                                                        itemControl.controls[
                                                            "cost"
                                                        ].value *
                                                            getHireQuantity(
                                                                itemControl
                                                            ) -
                                                            itemControl
                                                                .controls[
                                                                "discount"
                                                            ].value
                                                            | currency: "GBP"
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                                }
                            </ng-container>
                            } @if (getDealType() == DealType.Calibration &&
                            calibrationItems?.controls) {
                            <ng-container formArrayName="calibrationLines">
                                @for (itemControl of calibrationItems?.controls;
                                track itemControl; let i = $index) {
                                <ng-container [formGroupName]="i">
                                    <div
                                        class="border rounded-xl bg-white flex flex-col gap-4"
                                    >
                                        <div
                                            class="py-4 px-6 border-b flex gap-4 items-center"
                                        >
                                            <div>Line: {{ i + 1 }}</div>
                                            <div>
                                                Loadcell ID:
                                                {{
                                                    lookupLoadcell(itemControl)
                                                        ?.bookingRef
                                                }}
                                            </div>
                                            <div>Rev: 1</div>
                                            <div class="text-md">
                                                {{
                                                    lookupLoadcell(itemControl)
                                                        ?.customerCode
                                                }}
                                            </div>
                                            <div
                                                class="ml-auto text-primary text-xl"
                                            >
                                                {{
                                                    itemControl.controls["cost"]
                                                        .value *
                                                        itemControl.controls[
                                                            "quantity"
                                                        ].value -
                                                        itemControl.controls[
                                                            "discount"
                                                        ].value
                                                        | currency: "GBP"
                                                }}
                                            </div>
                                        </div>
                                        <div class="text-lg px-6">
                                            Specification:
                                        </div>
                                        <ul
                                            class="px-6 list-disc list-outside ml-6 flex flex-col gap-2"
                                        >
                                            <li>
                                                Quotation for
                                                {{
                                                    itemControl.controls[
                                                        "description"
                                                    ].value
                                                }}
                                            </li>
                                            <li>
                                                Product Code:
                                                {{
                                                    lookupLoadcell(itemControl)
                                                        ?.serialNumber
                                                }}
                                            </li>
                                            <li>
                                                Calibrated to industrial
                                                standards
                                            </li>
                                            <!-- <li>Quality controlled and tested prior to dispatch</li>
                                                                                <li>Full technical documentation included</li>
                                                                                <li>Supplied with material certificates and test reports</li> -->
                                        </ul>
                                        <div
                                            class="flex gap-8 px-6 py-4 bg-[#f8f8f8] mx-4 mb-4 rounded-md"
                                        >
                                            <div>
                                                <div class="text-lg mb-1">
                                                    Quantity
                                                </div>
                                                <div>
                                                    {{
                                                        itemControl.controls[
                                                            "quantity"
                                                        ].value
                                                    }}
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">
                                                    U/M
                                                </div>
                                                <div>EA</div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">
                                                    Unit Price
                                                </div>
                                                <div>
                                                    {{
                                                        itemControl.controls[
                                                            "cost"
                                                        ].value
                                                            | currency: "GBP"
                                                    }}
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">
                                                    Discount
                                                </div>
                                                <div>
                                                    <mat-form-field
                                                        class="fuse-mat-dense"
                                                        subscriptSizing="dynamic"
                                                    >
                                                        <input
                                                            matInput
                                                            type="number"
                                                            [formControlName]="
                                                                'discount'
                                                            "
                                                            (change)="
                                                                productsForm?.valid &&
                                                                    save(
                                                                        true,
                                                                        false,
                                                                        deal?.isWizardInFirstStage
                                                                    )
                                                            "
                                                        />
                                                        <span matPrefix>£</span>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">
                                                    Discount %
                                                </div>
                                                <div>
                                                    <mat-form-field
                                                        class="fuse-mat-dense"
                                                        subscriptSizing="dynamic"
                                                    >
                                                        <input
                                                            matInput
                                                            type="number"
                                                            [value]="
                                                                getDiscountPercentage(
                                                                    itemControl
                                                                )
                                                            "
                                                            (change)="
                                                                updateDiscountFromPercentage(
                                                                    $event,
                                                                    itemControl
                                                                )
                                                            "
                                                        />
                                                        <span matSuffix>%</span>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">
                                                    Lead Time
                                                </div>
                                                <div>
                                                    <mat-form-field
                                                        class="fuse-mat-dense"
                                                        subscriptSizing="dynamic"
                                                    >
                                                        <input
                                                            matInput
                                                            [formControlName]="
                                                                'leadTime'
                                                            "
                                                            (change)="
                                                                productsForm?.valid &&
                                                                    save(
                                                                        true,
                                                                        false,
                                                                        deal?.isWizardInFirstStage
                                                                    )
                                                            "
                                                        />
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">
                                                    Lead Time Type
                                                </div>
                                                <div>
                                                    <mat-form-field
                                                        class="fuse-mat-dense"
                                                        subscriptSizing="dynamic"
                                                    >
                                                        <mat-select
                                                            [formControlName]="
                                                                'leadTimeType'
                                                            "
                                                            (selectionChange)="
                                                                productsForm?.valid &&
                                                                    save(
                                                                        true,
                                                                        false,
                                                                        deal?.isWizardInFirstStage
                                                                    )
                                                            "
                                                        >
                                                            @for (option of
                                                            leadTimeTypes; track
                                                            option) {
                                                            <mat-option
                                                                [value]="
                                                                    option.value
                                                                "
                                                                >{{
                                                                    option.name
                                                                }}</mat-option
                                                            >
                                                            }
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">
                                                    Total Price
                                                </div>
                                                <div
                                                    class="text-primary text-lg"
                                                >
                                                    {{
                                                        itemControl.controls[
                                                            "cost"
                                                        ].value *
                                                            itemControl
                                                                .controls[
                                                                "quantity"
                                                            ].value -
                                                            itemControl
                                                                .controls[
                                                                "discount"
                                                            ].value
                                                            | currency: "GBP"
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                                }
                            </ng-container>
                            } @if (getDealType() == DealType.Marine &&
                            marineItems?.controls) {
                            <ng-container formArrayName="marineLines">
                                @for (itemControl of marineItems?.controls;
                                track itemControl; let i = $index) {
                                <ng-container [formGroupName]="i">
                                    <div
                                        class="border rounded-xl bg-white flex flex-col gap-4"
                                    >
                                        <div
                                            class="py-4 px-6 border-b flex gap-4 items-center"
                                        >
                                            <div>Line: {{ i + 1 }}</div>
                                            <div>
                                                Part:
                                                {{
                                                    itemControl.controls[
                                                        "partName"
                                                    ].value
                                                }}
                                            </div>
                                            <div>Rev: 1</div>
                                            <div class="text-md">
                                                {{
                                                    itemControl.controls[
                                                        "supplier"
                                                    ].value
                                                }}
                                            </div>
                                            <div
                                                class="ml-auto text-primary text-xl"
                                            >
                                                {{
                                                    itemControl.controls["cost"]
                                                        .value *
                                                        itemControl.controls[
                                                            "quantity"
                                                        ].value -
                                                        itemControl.controls[
                                                            "discount"
                                                        ].value
                                                        | currency: "GBP"
                                                }}
                                            </div>
                                        </div>
                                        <div class="text-lg px-6">
                                            Specification:
                                        </div>
                                        <ul
                                            class="px-6 list-disc list-outside ml-6 flex flex-col gap-2"
                                        >
                                            <li>
                                                Quotation for
                                                {{
                                                    itemControl.controls[
                                                        "partName"
                                                    ].value
                                                }}
                                            </li>
                                            <!-- <li>Product Code: {{itemControl.controls['partNumber'].value}}</li> -->
                                            <li>
                                                Manufactured to industrial
                                                standards
                                            </li>
                                            <li>
                                                Quality controlled and tested
                                                prior to dispatch
                                            </li>
                                            <li>
                                                Full technical documentation
                                                included
                                            </li>
                                            <li>
                                                Supplied with material
                                                certificates and test reports
                                            </li>
                                        </ul>
                                        <div
                                            class="flex gap-8 px-6 py-4 bg-[#f8f8f8] mx-4 mb-4 rounded-md"
                                        >
                                            <div>
                                                <div class="text-lg mb-1">
                                                    Quantity
                                                </div>
                                                <div>
                                                    {{
                                                        itemControl.controls[
                                                            "quantity"
                                                        ].value
                                                    }}
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">
                                                    U/M
                                                </div>
                                                <div>EA</div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">
                                                    Unit Price
                                                </div>
                                                <div>
                                                    {{
                                                        itemControl.controls[
                                                            "cost"
                                                        ].value
                                                            | currency: "GBP"
                                                    }}
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">
                                                    Discount
                                                </div>
                                                <div>
                                                    <mat-form-field
                                                        class="fuse-mat-dense"
                                                        subscriptSizing="dynamic"
                                                    >
                                                        <input
                                                            matInput
                                                            type="number"
                                                            [formControlName]="
                                                                'discount'
                                                            "
                                                            (change)="
                                                                productsForm?.valid &&
                                                                    save(
                                                                        true,
                                                                        false,
                                                                        deal?.isWizardInFirstStage
                                                                    )
                                                            "
                                                        />
                                                        <span matPrefix>£</span>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">
                                                    Discount %
                                                </div>
                                                <div>
                                                    <mat-form-field
                                                        class="fuse-mat-dense"
                                                        subscriptSizing="dynamic"
                                                    >
                                                        <input
                                                            matInput
                                                            type="number"
                                                            [value]="
                                                                getDiscountPercentage(
                                                                    itemControl
                                                                )
                                                            "
                                                            (change)="
                                                                updateDiscountFromPercentage(
                                                                    $event,
                                                                    itemControl
                                                                )
                                                            "
                                                        />
                                                        <span matSuffix>%</span>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">
                                                    Lead Time
                                                </div>
                                                <div>
                                                    <mat-form-field
                                                        class="fuse-mat-dense"
                                                        subscriptSizing="dynamic"
                                                    >
                                                        <input
                                                            matInput
                                                            [formControlName]="
                                                                'leadTime'
                                                            "
                                                            (change)="
                                                                productsForm?.valid &&
                                                                    save(
                                                                        true,
                                                                        false,
                                                                        deal?.isWizardInFirstStage
                                                                    )
                                                            "
                                                        />
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">
                                                    Lead Time Type
                                                </div>
                                                <div>
                                                    <mat-form-field
                                                        class="fuse-mat-dense"
                                                        subscriptSizing="dynamic"
                                                    >
                                                        <mat-select
                                                            [formControlName]="
                                                                'leadTimeType'
                                                            "
                                                            (selectionChange)="
                                                                productsForm?.valid &&
                                                                    save(
                                                                        true,
                                                                        false,
                                                                        deal?.isWizardInFirstStage
                                                                    )
                                                            "
                                                        >
                                                            @for (option of
                                                            leadTimeTypes; track
                                                            option) {
                                                            <mat-option
                                                                [value]="
                                                                    option.value
                                                                "
                                                                >{{
                                                                    option.name
                                                                }}</mat-option
                                                            >
                                                            }
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-lg mb-1">
                                                    Total Price
                                                </div>
                                                <div
                                                    class="text-primary text-lg"
                                                >
                                                    {{
                                                        itemControl.controls[
                                                            "cost"
                                                        ].value *
                                                            itemControl
                                                                .controls[
                                                                "quantity"
                                                            ].value -
                                                            itemControl
                                                                .controls[
                                                                "discount"
                                                            ].value
                                                            | currency: "GBP"
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                                }
                            </ng-container>
                            } @if (isCustomQuote() && partItems?.controls) {
                            <ng-container formArrayName="partLines">
                                <!-- show as one product line -->
                                <div
                                    class="border rounded-xl bg-white flex flex-col gap-4"
                                >
                                    <div
                                        class="py-4 px-6 border-b flex gap-4 items-center"
                                    >
                                        <div>Line: 1</div>
                                        <div>
                                            Product ID:
                                            {{ customProductPartNumber | productNumber }}
                                        </div>
                                        <div>Rev: 1</div>
                                        <!-- <div class="text-md">{{lookupPart(itemControl)?.description}}</div> -->
                                        <div
                                            class="ml-auto text-primary text-xl"
                                        >
                                            {{
                                                getTotalPrice()
                                                    | currency: "GBP"
                                            }}
                                        </div>
                                    </div>
                                    <div class="text-lg px-6">
                                        Specification:
                                    </div>
                                    <ul
                                        class="px-6 list-disc list-outside ml-6 flex flex-col gap-2"
                                    >
                                        <li>
                                            Quotation for
                                            {{ customProductName }}
                                        </li>
                                        <li>
                                            Product Code:
                                            {{ customProductPartNumber | productNumber }}
                                        </li>
                                        <li>
                                            Manufactured to industrial standards
                                        </li>
                                        <li>
                                            Quality controlled and tested prior
                                            to dispatch
                                        </li>
                                        <li>
                                            Full technical documentation
                                            included
                                        </li>
                                        <li>
                                            Supplied with material certificates
                                            and test reports
                                        </li>
                                    </ul>
                                    <div
                                        class="flex gap-8 px-6 py-4 bg-[#f8f8f8] mx-4 mb-4 rounded-md"
                                    >
                                        <div>
                                            <div class="text-lg mb-1">
                                                Quantity
                                            </div>
                                            <div>1</div>
                                        </div>
                                        <div>
                                            <div class="text-lg mb-1">U/M</div>
                                            <div>EA</div>
                                        </div>
                                        <div>
                                            <div class="text-lg mb-1">
                                                Unit Price
                                            </div>
                                            <div>
                                                {{
                                                    getTotalPrice()
                                                        | currency: "GBP"
                                                }}
                                            </div>
                                        </div>
                                        @for (itemControl of
                                        partItems?.controls; track itemControl;
                                        let i = $index; let first = $first) {
                                        <ng-container [formGroupName]="i">
                                            @if (first) {
                                            <div>
                                                <div class="text-lg">
                                                    Lead Time
                                                </div>
                                                <div>
                                                    <mat-form-field
                                                        class="fuse-mat-dense"
                                                        subscriptSizing="dynamic"
                                                    >
                                                        <input
                                                            matInput
                                                            [formControlName]="
                                                                'leadTime'
                                                            "
                                                            (change)="
                                                                productsForm?.valid &&
                                                                    save(
                                                                        true,
                                                                        false,
                                                                        deal?.isWizardInFirstStage
                                                                    )
                                                            "
                                                        />
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            } @if (first) {
                                            <div>
                                                <div class="text-lg">
                                                    Lead Time Type
                                                </div>
                                                <div>
                                                    <mat-form-field
                                                        class="fuse-mat-dense"
                                                        subscriptSizing="dynamic"
                                                    >
                                                        <mat-select
                                                            [formControlName]="
                                                                'leadTimeType'
                                                            "
                                                            (selectionChange)="
                                                                productsForm?.valid &&
                                                                    save(
                                                                        true,
                                                                        false,
                                                                        deal?.isWizardInFirstStage
                                                                    )
                                                            "
                                                        >
                                                            @for (option of
                                                            leadTimeTypes; track
                                                            option) {
                                                            <mat-option
                                                                [value]="
                                                                    option.value
                                                                "
                                                                >{{
                                                                    option.name
                                                                }}</mat-option
                                                            >
                                                            }
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            }
                                        </ng-container>
                                        }
                                        <div>
                                            <div class="text-lg mb-1">
                                                Total Price
                                            </div>
                                            <div class="text-primary text-lg">
                                                {{
                                                    getTotalPrice()
                                                        | currency: "GBP"
                                                }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <ng-container *ngFor="let itemControl of partItems?.controls; let i = index" [formGroupName]="i">
                                                                                      <div class="border rounded-xl bg-white flex flex-col gap-4">
                                                                                        <div class="py-4 px-6 border-b flex gap-4 items-center">
                                                                                          <div>Line: {{i+1}}</div>
                                                                                          <div>Part ID: {{lookupPart(itemControl)?.number}}</div>
                                                                                          <div>Rev: 1</div>
                                                                                          <div class="text-md">{{lookupPart(itemControl)?.description}}</div>
                                                                                          <div class="ml-auto text-primary text-xl">{{itemControl.controls['cost'].value * itemControl.controls['quantity'].value | currency:'GBP'}}</div>
                                                                                        </div>
                                                                                        <div class="text-lg px-6">Specification:</div>
                                                                                        <ul class="px-6 list-disc list-outside ml-6 flex flex-col gap-2">
                                                                                          <li>Quotation for {{lookupPart(itemControl)?.description}}</li>
                                                                                          <li>Product Code: {{lookupPart(itemControl)?.number}}</li>
                                                                                          <li>Manufactured to industrial standards</li>
                                                                                          <li>Quality controlled and tested prior to dispatch</li>
                                                                                          <li>Full technical documentation included</li>
                                                                                          <li>Supplied with material certificates and test reports</li>
                                                                                        </ul>
                                                                                        <div class="flex gap-8 px-6 py-4 bg-[#f8f8f8] mx-4 mb-4 rounded-md">
                                                                                          <div>
                                                                                            <div class="text-lg mb-1">Quantity</div>
                                                                                            <div>{{itemControl.controls['quantity'].value}}</div>
                                                                                          </div>
                                                                                          <div>
                                                                                            <div class="text-lg mb-1">U/M</div>
                                                                                            <div>EA</div>
                                                                                          </div>
                                                                                          <div>
                                                                                            <div class="text-lg mb-1">Unit Price</div>
                                                                                            <div>{{itemControl.controls['cost'].value | currency:'GBP'}}</div>
                                                                                          </div>
                                                                                          <div>
                                                                                            <div class="text-lg">Lead Time</div>
                                                                                            <div>
                                                                                              <mat-form-field class="fuse-mat-dense" subscriptSizing="dynamic">
                                                                                                <input matInput [formControlName]="'leadTime'">
                                                                                              </mat-form-field>
                                                                                            </div>
                                                                                          </div>
                                                                                          <div>
                                                                                            <div class="text-lg mb-1">Total Price</div>
                                                                                            <div class="text-primary text-lg">{{itemControl.controls['cost'].value * itemControl.controls['quantity'].value | currency:'GBP'}}</div>
                                                                                          </div>
                                                                                        </div>
                                                                                      </div>
                                                                                    </ng-container> -->
                            </ng-container>
                            }
                        </form>
                        }

                        <!-- Margins, Shipping and Totals -->
                        @if (summaryForm) {
                        <form
                            [formGroup]="summaryForm"
                            class="flex flex-col gap-4"
                        >
                            <!-- Payments & Margin (unified) -->
                            <div
                                class="border rounded-xl bg-white gap-4 py-4 px-6 grid grid-cols-2"
                            >
                                <div class="col-span-2 text-xl">
                                    Payments & Margin
                                </div>

                                <!-- Payment Terms — always shown, full width -->
                                <mat-form-field
                                    class="fuse-mat-dense col-span-2"
                                    subscriptSizing="dynamic"
                                >
                                    <mat-label>Payment Terms</mat-label>
                                    <mat-select
                                        [formControlName]="'paymentTerm'"
                                        (selectionChange)="
                                            summaryForm?.valid &&
                                                save(
                                                    true,
                                                    false,
                                                    deal?.isWizardInFirstStage
                                                )
                                        "
                                    >
                                        @for (option of paymentTerms; track
                                        option.value) {
                                        <mat-option [value]="option.value">{{
                                            option.name
                                        }}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>

                                <!-- Margin sub-section — shown for all quote types.
                                     Standard/Custom presets pull from /settings/markups;
                                     the % is applied as a markup on the line sale price. -->
                                @if (summaryForm) {
                                <mat-form-field
                                    class="fuse-mat-dense"
                                    subscriptSizing="dynamic"
                                >
                                    <mat-label>Margin Type</mat-label>
                                    <mat-select
                                        [formControlName]="'marginType'"
                                        (selectionChange)="
                                            onMarginTypeChanged($event)
                                        "
                                    >
                                        @for (option of marginTypes; track
                                        option) {
                                        <mat-option [value]="option.value">{{
                                            option.name
                                        }}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                                @if
                                (!!summaryForm?.controls['marginType'].value) {
                                <mat-form-field
                                    class="fuse-mat-dense"
                                    subscriptSizing="dynamic"
                                >
                                    <mat-label>Margin %</mat-label>
                                    <input
                                        matInput
                                        type="number"
                                        [formControlName]="'margin'"
                                        min="0"
                                        [readonly]="!isMarginManual()"
                                        (change)="
                                            summaryForm?.valid &&
                                                save(
                                                    true,
                                                    false,
                                                    deal?.isWizardInFirstStage
                                                )
                                        "
                                    />
                                    <span matSuffix>%</span>
                                </mat-form-field>
                                <div
                                    class="col-span-2 p-4 border rounded-lg grid grid-cols-3"
                                    style="
                                        background: rgb(240, 249, 255);
                                        border-color: rgb(191, 219, 254);
                                    "
                                >
                                    <div>
                                        <div class="text-lg mb-2">
                                            Total Cost
                                        </div>
                                        <div class="text-lg">
                                            {{
                                                getTotalPrice()
                                                    | currency: "GBP"
                                            }}
                                        </div>
                                    </div>
                                    <div>
                                        <div class="text-lg mb-2">
                                            Margin Amount
                                        </div>
                                        <div class="text-lg">
                                            {{
                                                (getTotalPrice() *
                                                    summaryForm.controls[
                                                        "margin"
                                                    ].value) /
                                                    100 | currency: "GBP"
                                            }}
                                        </div>
                                    </div>
                                    <div>
                                        <div class="text-lg mb-2">
                                            Selling Price
                                        </div>
                                        <div class="text-lg">
                                            {{
                                                getTotalPrice() *
                                                    getMarginModifier()
                                                    | currency: "GBP"
                                            }}
                                        </div>
                                    </div>
                                </div>
                                }
                                }
                            </div>
                            <!-- Freight/Shipping -->
                            <div
                                class="border rounded-xl bg-white gap-4 py-4 px-6 grid grid-cols-2"
                            >
                                <div class="col-span-2 text-xl">
                                    Freight & Shipping Details
                                </div>
                                <mat-form-field
                                    class="fuse-mat-dense"
                                    subscriptSizing="dynamic"
                                >
                                    <mat-label>Incoterms</mat-label>
                                    <mat-select
                                        [formControlName]="'incoterm'"
                                        (selectionChange)="
                                            summaryForm?.valid &&
                                                save(
                                                    true,
                                                    false,
                                                    deal?.isWizardInFirstStage
                                                )
                                        "
                                    >
                                        @for (option of incoterms; track option)
                                        {
                                        <mat-option [value]="option.value">{{
                                            option.name
                                        }}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field
                                    class="fuse-mat-dense"
                                    subscriptSizing="dynamic"
                                >
                                    <mat-label>Freight Service</mat-label>
                                    <mat-select
                                        [formControlName]="'freightTerm'"
                                        (selectionChange)="
                                            summaryForm?.valid &&
                                                save(
                                                    true,
                                                    false,
                                                    deal?.isWizardInFirstStage
                                                )
                                        "
                                    >
                                        @for (option of freightTerms; track
                                        option) {
                                        <mat-option [value]="option.value">{{
                                            option.name
                                        }}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field
                                    class="fuse-mat-dense"
                                    subscriptSizing="dynamic"
                                >
                                    <mat-label>Transport Mode</mat-label>
                                    <mat-select
                                        [formControlName]="'transportMode'"
                                        (selectionChange)="
                                            summaryForm?.valid &&
                                                save(
                                                    true,
                                                    false,
                                                    deal?.isWizardInFirstStage
                                                )
                                        "
                                    >
                                        @for (option of transportModes; track
                                        option) {
                                        <mat-option [value]="option.value">{{
                                            option.name
                                        }}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field
                                    class="fuse-mat-dense"
                                    subscriptSizing="dynamic"
                                >
                                    <mat-label>Freight Cost</mat-label>
                                    <input
                                        matInput
                                        type="number"
                                        [formControlName]="'freightCost'"
                                        (change)="
                                            summaryForm?.valid &&
                                                save(
                                                    true,
                                                    false,
                                                    deal?.isWizardInFirstStage
                                                )
                                        "
                                    />
                                    <span matPrefix>£</span>
                                </mat-form-field>
                                <mat-form-field
                                    class="fuse-mat-dense"
                                    subscriptSizing="dynamic"
                                >
                                    <mat-label>VAT Rate</mat-label>
                                    <mat-select
                                        [formControlName]="'vatRate'"
                                        (selectionChange)="
                                            summaryForm?.valid &&
                                                save(
                                                    true,
                                                    false,
                                                    deal?.isWizardInFirstStage
                                                )
                                        "
                                    >
                                        @for (option of vatRates; track option)
                                        {
                                        <mat-option [value]="option.value">{{
                                            option.name
                                        }}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                                <!-- <div class="col-span-2 border rounded-lg p-5" style="background: #fffbeb !important; border-color: #fcd34d;">
                                                                                      <div class="flex items-start gap-3">
                                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="info" style="width: 16px; height: 16px; color: #f59e0b; flex-shrink: 0; margin-top: 2px;" class="lucide lucide-info"><circle cx="12" cy="12" r="10"></circle><path d="M12 16v-4"></path><path d="M12 8h.01"></path></svg>
                                                                                        <div class="text-[#92400e]" style="line-height: 1.5;">
                                                                                          <strong>Important:</strong> Rates exclude Customs Clearance, US bond, and Duty. Transit time is approximately 30 days from successful sailing date. Transit times are subject to space availability and pending no delays.
                                                                                        </div>
                                                                                      </div>
                                                                                    </div> -->
                            </div>
                            <!-- Quote Validity -->
                            <div
                                class="border rounded-xl bg-white gap-2 py-4 px-6 flex flex-col"
                            >
                                <div class="text-xl">Quote Validity</div>
                                <div class="text-secondary">
                                    Please note this quotation is valid for 30 days from the date issued. After this period pricing, availability and lead times may be subject to change.
                                </div>
                            </div>
                            <!-- Totals -->
                            <div
                                class="border border-primary border-2 rounded-xl bg-white divide-y py-4 px-6 flex flex-col"
                            >
                                <div class="flex justify-between py-4 text-lg">
                                    <div>Subtotal:</div>
                                    <div>
                                        {{
                                            getTotalPrice() *
                                                getMarginModifier()
                                                | currency: "GBP"
                                        }}
                                    </div>
                                </div>
                                <div class="flex justify-between py-4 text-lg">
                                    <div>Freight:</div>
                                    <div>
                                        {{
                                            summaryForm.controls["freightCost"]
                                                .value | currency: "GBP"
                                        }}
                                    </div>
                                </div>
                                <div class="flex justify-between py-4 text-lg">
                                    <div>
                                        VAT ({{
                                            summaryForm.controls["vatRate"]
                                                .value * 100
                                        }}%):
                                    </div>
                                    <div>
                                        {{
                                            getTotalPrice() *
                                                getMarginModifier() *
                                                summaryForm.controls["vatRate"]
                                                    .value | currency: "GBP"
                                        }}
                                    </div>
                                </div>
                                <div class="flex justify-between py-4 text-2xl">
                                    <div>Total (inc VAT):</div>
                                    <div class="text-primary">
                                        {{
                                            getTotalPrice() *
                                                getMarginModifier() *
                                                (1 +
                                                    summaryForm.controls[
                                                        "vatRate"
                                                    ].value) +
                                                summaryForm.controls[
                                                    "freightCost"
                                                ].value | currency: "GBP"
                                        }}
                                    </div>
                                </div>
                            </div>
                        </form>
                        }
                    </div>

                    <div class="flex flex-col gap-2">
                        @if (hasZeroCostLines()) {
                        <p class="text-red-600 text-sm text-right">
                            {{ getZeroCostLineCount() }} line(s) have £0 cost.
                            Set a price on each before continuing.
                        </p>
                        }
                        <div class="flex justify-between gap-4">
                            <button
                                mat-stroked-button
                                matStepperPrevious
                                type="button"
                            >
                                Back
                            </button>
                            @if (!dealId || deal?.isWizardInProgress) {
                            <button
                                class="ml-auto"
                                (click)="save(true, true)"
                                mat-stroked-button
                                type="button"
                                [disabled]="!summaryForm?.valid"
                            >
                                Save Progress
                            </button>
                            }
                            <button
                                mat-flat-button
                                matStepperNext
                                type="button"
                                [color]="'primary'"
                                [disabled]="
                                    !summaryForm?.valid || hasZeroCostLines()
                                "
                            >
                                Next
                            </button>
                        </div>
                    </div>
                </div>
            </mat-step>

            <!-- PDF Step -->
            <mat-step label="Preview & Send">
                <div class="w-full flex flex-col gap-4 mt-4 pr-2">
                    <div
                        class="flex flex-col p-6 mb-6 border gap-8"
                        id="print-section"
                    >
                        <div class="w-full">
                            <header>
                                <img
                                    [src]="branding.headerSrc"
                                />
                            </header>

                            <div
                                class="flex flex-col items-center gap-2 py-4 w-full border-b"
                            >
                                <div style="font-size: 22px !important">
                                    QUOTATION
                                </div>
                                <div class="text-lg">
                                    Reference:
                                    {{
                                        deal?.quoteNumber ||
                                            deal?.quoteRef ||
                                            ""
                                    }}
                                </div>
                            </div>
                        </div>

                        <div class="grid grid-cols-2 mx-4">
                            <div class="flex flex-col gap-2">
                                <div class="uppercase">Customer Details</div>
                                <div class="text-xl">
                                    {{ selectedCompanyName }}
                                </div>
                                <div>
                                    {{ getContactEmail() }}
                                    <br />
                                    {{ getContactPhoneNumber() }}
                                </div>
                                <div>{{ getCompany()?.address }}</div>
                            </div>
                            <div class="flex flex-col gap-2">
                                <div class="uppercase">Quote Details</div>
                                <div>
                                    Title:
                                    {{ customerForm?.controls["name"].value }}
                                </div>
                                <div>Contact: {{ getContactName() }}</div>
                                <div>
                                    Date:
                                    {{ getTodaysDate() | date: "d MMM yyyy" }}
                                </div>
                            </div>
                        </div>

                        <div class="uppercase mx-4">Items</div>

                        <div class="border mx-4 -mt-4">
                            @if (productsForm) {
                            <form
                                [formGroup]="productsForm"
                                class="flex flex-col divide-y"
                            >
                                @if ((getDealType() == DealType.Standard ||
                                getDealType() == DealType.RepeatCustom) &&
                                productItems?.controls) {
                                <ng-container formArrayName="productLines">
                                    @for (itemControl of productItems?.controls;
                                    track itemControl; let i = $index) {
                                    <ng-container [formGroupName]="i">
                                        <div class="flex flex-col gap-3 p-5">
                                            <div
                                                class="border-b flex gap-4 items-center pb-3"
                                            >
                                                <div>Line: {{ i + 1 }}</div>
                                                <div>
                                                    Product ID:
                                                    {{
                                                        lookupProduct(
                                                            itemControl
                                                        )?.partNumber
                                                            | productNumber
                                                    }}
                                                </div>
                                                <div>Rev: 1</div>
                                            </div>
                                            <div class="text-lg">
                                                {{
                                                    lookupProduct(itemControl)
                                                        ?.description
                                                }}
                                            </div>
                                            <div>Specification:</div>
                                            <ul
                                                class="-mt-2 list-disc list-outside ml-6 flex flex-col"
                                            >
                                                <li>
                                                    Quotation for
                                                    {{
                                                        lookupProduct(
                                                            itemControl
                                                        )?.description
                                                    }}
                                                </li>
                                                <li>
                                                    Product Code:
                                                    {{
                                                        lookupProduct(
                                                            itemControl
                                                        )?.partNumber
                                                            | productNumber
                                                    }}
                                                </li>
                                                <li>
                                                    Manufactured to industrial
                                                    standards
                                                </li>
                                                <li>
                                                    Quality controlled and
                                                    tested prior to dispatch
                                                </li>
                                                <li>
                                                    Full technical documentation
                                                    included
                                                </li>
                                                <li>
                                                    Supplied with material
                                                    certificates and test
                                                    reports
                                                </li>
                                            </ul>
                                            <div
                                                class="flex gap-8 px-6 py-3 bg-gray-50 mt-1"
                                            >
                                                <div>
                                                    <div class="mb-1">
                                                        Quantity
                                                    </div>
                                                    <div>
                                                        {{
                                                            itemControl
                                                                .controls[
                                                                "quantity"
                                                            ].value
                                                        }}
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">U/M</div>
                                                    <div>EA</div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">
                                                        Unit Price
                                                    </div>
                                                    <div>
                                                        {{
                                                            itemControl
                                                                .controls[
                                                                "cost"
                                                            ].value
                                                                | currency
                                                                    : "GBP"
                                                        }}
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">
                                                        Discount
                                                    </div>
                                                    <div>
                                                        {{
                                                            itemControl
                                                                .controls[
                                                                "discount"
                                                            ].value
                                                                | currency
                                                                    : "GBP"
                                                        }}
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">
                                                        Lead Time
                                                    </div>
                                                    <div>
                                                        {{
                                                            itemControl
                                                                .controls[
                                                                "leadTime"
                                                            ].value
                                                        }}
                                                        {{
                                                            getLeadTimeTypeName(
                                                                itemControl
                                                                    .controls[
                                                                    "leadTimeType"
                                                                ].value
                                                            ) | lowercase
                                                        }}
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">
                                                        Total Price
                                                    </div>
                                                    <div class="text-primary">
                                                        {{
                                                            itemControl
                                                                .controls[
                                                                "cost"
                                                            ].value *
                                                                itemControl
                                                                    .controls[
                                                                    "quantity"
                                                                ].value -
                                                                itemControl
                                                                    .controls[
                                                                    "discount"
                                                                ].value
                                                                | currency
                                                                    : "GBP"
                                                        }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                    }
                                </ng-container>
                                } @if (getDealType() == DealType.Hire &&
                                hireItems?.controls) {
                                <ng-container formArrayName="hireLines">
                                    @for (itemControl of hireItems?.controls;
                                    track itemControl; let i = $index) {
                                    <ng-container [formGroupName]="i">
                                        <div class="flex flex-col gap-3 p-5">
                                            <div
                                                class="border-b flex gap-4 items-center pb-3"
                                            >
                                                <div>Line: {{ i + 1 }}</div>
                                                <div>
                                                    Asset ID:
                                                    {{
                                                        lookupAsset(itemControl)
                                                            ?.serialNumber
                                                    }}
                                                </div>
                                                <div>Rev: 1</div>
                                            </div>
                                            <div class="text-lg">
                                                {{
                                                    lookupAsset(itemControl)
                                                        ?.name
                                                }}
                                            </div>
                                            <div>Specification:</div>
                                            <ul
                                                class="-mt-2 list-disc list-outside ml-6 flex flex-col"
                                            >
                                                <li>
                                                    Quotation for
                                                    {{
                                                        lookupAsset(itemControl)
                                                            ?.name
                                                    }}
                                                </li>
                                                <li>
                                                    Product Code:
                                                    {{
                                                        lookupAsset(itemControl)
                                                            ?.serialNumber
                                                    }}
                                                </li>
                                                <li>
                                                    Manufactured to industrial
                                                    standards
                                                </li>
                                                <li>
                                                    Quality controlled and
                                                    tested prior to dispatch
                                                </li>
                                                <li>
                                                    Full technical documentation
                                                    included
                                                </li>
                                                <li>
                                                    Supplied with material
                                                    certificates and test
                                                    reports
                                                </li>
                                            </ul>
                                            <div
                                                class="flex gap-8 px-6 py-3 bg-gray-50 mt-1"
                                            >
                                                <div>
                                                    <div class="mb-1">
                                                        Quantity
                                                    </div>
                                                    <div>
                                                        {{
                                                            getHireQuantity(
                                                                itemControl
                                                            )
                                                        }}
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">U/M</div>
                                                    <div>EA</div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">
                                                        Unit Price
                                                    </div>
                                                    <div>
                                                        {{
                                                            itemControl
                                                                .controls[
                                                                "cost"
                                                            ].value
                                                                | currency
                                                                    : "GBP"
                                                        }}
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">
                                                        Discount
                                                    </div>
                                                    <div>
                                                        {{
                                                            itemControl
                                                                .controls[
                                                                "discount"
                                                            ].value
                                                                | currency
                                                                    : "GBP"
                                                        }}
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">
                                                        Lead Time
                                                    </div>
                                                    <div>
                                                        {{
                                                            itemControl
                                                                .controls[
                                                                "leadTime"
                                                            ].value
                                                        }}
                                                        {{
                                                            getLeadTimeTypeName(
                                                                itemControl
                                                                    .controls[
                                                                    "leadTimeType"
                                                                ].value
                                                            ) | lowercase
                                                        }}
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">
                                                        Total Price
                                                    </div>
                                                    <div class="text-primary">
                                                        {{
                                                            itemControl
                                                                .controls[
                                                                "cost"
                                                            ].value *
                                                                getHireQuantity(
                                                                    itemControl
                                                                ) -
                                                                itemControl
                                                                    .controls[
                                                                    "discount"
                                                                ].value
                                                                | currency
                                                                    : "GBP"
                                                        }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                    }
                                </ng-container>
                                } @if (getDealType() == DealType.Calibration &&
                                calibrationItems?.controls) {
                                <ng-container formArrayName="calibrationLines">
                                    @for (itemControl of
                                    calibrationItems?.controls; track
                                    itemControl; let i = $index) {
                                    <ng-container [formGroupName]="i">
                                        <div class="flex flex-col gap-3 p-5">
                                            <div
                                                class="border-b flex gap-4 items-center pb-3"
                                            >
                                                <div>Line: {{ i + 1 }}</div>
                                                <div>
                                                    Loadcell ID:
                                                    {{
                                                        lookupLoadcell(
                                                            itemControl
                                                        )?.bookingRef
                                                    }}
                                                </div>
                                                <div>Rev: 1</div>
                                            </div>
                                            <div class="text-lg">
                                                {{
                                                    lookupLoadcell(itemControl)
                                                        ?.customerCode
                                                }}
                                            </div>
                                            <div>Specification:</div>
                                            <ul
                                                class="-mt-2 list-disc list-outside ml-6 flex flex-col"
                                            >
                                                <li>
                                                    Quotation for
                                                    {{
                                                        itemControl.controls[
                                                            "description"
                                                        ].value
                                                    }}
                                                </li>
                                                <li>
                                                    Product Code:
                                                    {{
                                                        lookupLoadcell(
                                                            itemControl
                                                        )?.serialNumber
                                                    }}
                                                </li>
                                                <li>
                                                    Calibrated to industrial
                                                    standards
                                                </li>
                                                <!-- <li>Quality controlled and tested prior to dispatch</li>
                                                                                                <li>Full technical documentation included</li>
                                                                                                <li>Supplied with material certificates and test reports</li> -->
                                            </ul>
                                            <div
                                                class="flex gap-8 px-6 py-3 bg-gray-50 mt-1"
                                            >
                                                <div>
                                                    <div class="mb-1">
                                                        Quantity
                                                    </div>
                                                    <div>
                                                        {{
                                                            itemControl
                                                                .controls[
                                                                "quantity"
                                                            ].value
                                                        }}
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">U/M</div>
                                                    <div>EA</div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">
                                                        Unit Price
                                                    </div>
                                                    <div>
                                                        {{
                                                            itemControl
                                                                .controls[
                                                                "cost"
                                                            ].value
                                                                | currency
                                                                    : "GBP"
                                                        }}
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">
                                                        Discount
                                                    </div>
                                                    <div>
                                                        {{
                                                            itemControl
                                                                .controls[
                                                                "discount"
                                                            ].value
                                                                | currency
                                                                    : "GBP"
                                                        }}
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">
                                                        Lead Time
                                                    </div>
                                                    <div>
                                                        {{
                                                            itemControl
                                                                .controls[
                                                                "leadTime"
                                                            ].value
                                                        }}
                                                        {{
                                                            getLeadTimeTypeName(
                                                                itemControl
                                                                    .controls[
                                                                    "leadTimeType"
                                                                ].value
                                                            ) | lowercase
                                                        }}
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">
                                                        Total Price
                                                    </div>
                                                    <div class="text-primary">
                                                        {{
                                                            itemControl
                                                                .controls[
                                                                "cost"
                                                            ].value *
                                                                itemControl
                                                                    .controls[
                                                                    "quantity"
                                                                ].value -
                                                                itemControl
                                                                    .controls[
                                                                    "discount"
                                                                ].value
                                                                | currency
                                                                    : "GBP"
                                                        }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                    }
                                </ng-container>
                                } @if (getDealType() == DealType.Marine &&
                                marineItems?.controls) {
                                <ng-container formArrayName="marineLines">
                                    @for (itemControl of marineItems?.controls;
                                    track itemControl; let i = $index) {
                                    <ng-container [formGroupName]="i">
                                        <div class="flex flex-col gap-3 p-5">
                                            <div
                                                class="border-b flex gap-4 items-center pb-3"
                                            >
                                                <div>Line: {{ i + 1 }}</div>
                                                <div>
                                                    Part:
                                                    {{
                                                        itemControl.controls[
                                                            "partName"
                                                        ].value
                                                    }}
                                                </div>
                                                <div>Rev: 1</div>
                                            </div>
                                            <div class="text-lg">
                                                {{
                                                    itemControl.controls[
                                                        "supplier"
                                                    ].value
                                                }}
                                            </div>
                                            <div>Specification:</div>
                                            <ul
                                                class="-mt-2 list-disc list-outside ml-6 flex flex-col"
                                            >
                                                <li>
                                                    Quotation for
                                                    {{
                                                        itemControl.controls[
                                                            "partName"
                                                        ].value
                                                    }}
                                                </li>
                                                <!-- <li>Product Code: {{itemControl.controls['partNumber'].value}}</li> -->
                                                <li>
                                                    Manufactured to industrial
                                                    standards
                                                </li>
                                                <li>
                                                    Quality controlled and
                                                    tested prior to dispatch
                                                </li>
                                                <li>
                                                    Full technical documentation
                                                    included
                                                </li>
                                                <li>
                                                    Supplied with material
                                                    certificates and test
                                                    reports
                                                </li>
                                            </ul>
                                            <div
                                                class="flex gap-8 px-6 py-3 bg-gray-50 mt-1"
                                            >
                                                <div>
                                                    <div class="mb-1">
                                                        Quantity
                                                    </div>
                                                    <div>
                                                        {{
                                                            itemControl
                                                                .controls[
                                                                "quantity"
                                                            ].value
                                                        }}
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">U/M</div>
                                                    <div>EA</div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">
                                                        Unit Price
                                                    </div>
                                                    <div>
                                                        {{
                                                            itemControl
                                                                .controls[
                                                                "cost"
                                                            ].value
                                                                | currency
                                                                    : "GBP"
                                                        }}
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">
                                                        Discount
                                                    </div>
                                                    <div>
                                                        {{
                                                            itemControl
                                                                .controls[
                                                                "discount"
                                                            ].value
                                                                | currency
                                                                    : "GBP"
                                                        }}
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">
                                                        Lead Time
                                                    </div>
                                                    <div>
                                                        {{
                                                            itemControl
                                                                .controls[
                                                                "leadTime"
                                                            ].value
                                                        }}
                                                        {{
                                                            getLeadTimeTypeName(
                                                                itemControl
                                                                    .controls[
                                                                    "leadTimeType"
                                                                ].value
                                                            ) | lowercase
                                                        }}
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="mb-1">
                                                        Total Price
                                                    </div>
                                                    <div class="text-primary">
                                                        {{
                                                            itemControl
                                                                .controls[
                                                                "cost"
                                                            ].value *
                                                                itemControl
                                                                    .controls[
                                                                    "quantity"
                                                                ].value -
                                                                itemControl
                                                                    .controls[
                                                                    "discount"
                                                                ].value
                                                                | currency
                                                                    : "GBP"
                                                        }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                    }
                                </ng-container>
                                } @if (isCustomQuote() && partItems?.controls) {
                                <ng-container formArrayName="partLines">
                                    <!-- show as one product line -->
                                    <div class="flex flex-col gap-3 p-5">
                                        <div
                                            class="border-b flex gap-4 items-center pb-3"
                                        >
                                            <div>Line: 1</div>
                                            <div>
                                                Product ID:
                                                {{ customProductPartNumber | productNumber }}
                                            </div>
                                            <div>Rev: 1</div>
                                        </div>
                                        <!-- <div class="text-lg">{{lookupPart(itemControl)?.description}}</div> -->
                                        <div>Specification:</div>
                                        <ul
                                            class="-mt-2 list-disc list-outside ml-6 flex flex-col"
                                        >
                                            <li>
                                                Quotation for
                                                {{ customProductName }}
                                            </li>
                                            <li>
                                                Product Code:
                                                {{ customProductPartNumber | productNumber }}
                                            </li>
                                            <li>
                                                Manufactured to industrial
                                                standards
                                            </li>
                                            <li>
                                                Quality controlled and tested
                                                prior to dispatch
                                            </li>
                                            <li>
                                                Full technical documentation
                                                included
                                            </li>
                                            <li>
                                                Supplied with material
                                                certificates and test reports
                                            </li>
                                        </ul>
                                        <div
                                            class="flex gap-8 px-6 py-3 bg-gray-50 mt-1"
                                        >
                                            <div>
                                                <div class="mb-1">Quantity</div>
                                                <div>1</div>
                                            </div>
                                            <div>
                                                <div class="mb-1">U/M</div>
                                                <div>EA</div>
                                            </div>
                                            <div>
                                                <div class="mb-1">
                                                    Unit Price
                                                </div>
                                                <div>
                                                    {{
                                                        getTotalPrice()
                                                            | currency: "GBP"
                                                    }}
                                                </div>
                                            </div>
                                            @for (itemControl of
                                            partItems?.controls; track
                                            itemControl; let i = $index; let
                                            first = $first) {
                                            <ng-container [formGroupName]="i">
                                                @if (first) {
                                                <div>
                                                    <div class="mb-1">
                                                        Lead Time
                                                    </div>
                                                    <div>
                                                        {{
                                                            itemControl
                                                                .controls[
                                                                "leadTime"
                                                            ].value
                                                        }}
                                                        {{
                                                            getLeadTimeTypeName(
                                                                itemControl
                                                                    .controls[
                                                                    "leadTimeType"
                                                                ].value
                                                            ) | lowercase
                                                        }}
                                                    </div>
                                                </div>
                                                }
                                            </ng-container>
                                            }
                                            <div>
                                                <div class="mb-1">
                                                    Total Price
                                                </div>
                                                <div class="text-primary">
                                                    {{
                                                        getTotalPrice()
                                                            | currency: "GBP"
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <ng-container *ngFor="let itemControl of partItems?.controls; let i = index" [formGroupName]="i">
                                                                                        <div class="flex flex-col gap-3 p-5">
                                                                                          <div class="border-b flex gap-4 items-center pb-3">
                                                                                            <div>Line: {{i+1}}</div>
                                                                                            <div>Part ID: {{lookupPart(itemControl)?.number}}</div>
                                                                                            <div>Rev: 1</div>
                                                                                          </div>
                                                                                          <div class="text-lg">{{lookupPart(itemControl)?.description}}</div>
                                                                                          <div>Specification:</div>
                                                                                          <ul class="-mt-2 list-disc list-outside ml-6 flex flex-col">
                                                                                            <li>Quotation for {{lookupPart(itemControl)?.description}}</li>
                                                                                            <li>Product Code: {{lookupPart(itemControl)?.number}}</li>
                                                                                            <li>Manufactured to industrial standards</li>
                                                                                            <li>Quality controlled and tested prior to dispatch</li>
                                                                                            <li>Full technical documentation included</li>
                                                                                            <li>Supplied with material certificates and test reports</li>
                                                                                          </ul>
                                                                                          <div class="flex gap-8 px-6 py-3 bg-gray-50 mt-1">
                                                                                            <div>
                                                                                              <div class="mb-1">Quantity</div>
                                                                                              <div>{{itemControl.controls['quantity'].value}}</div>
                                                                                            </div>
                                                                                            <div>
                                                                                              <div class="mb-1">U/M</div>
                                                                                              <div>EA</div>
                                                                                            </div>
                                                                                            <div>
                                                                                              <div class="mb-1">Unit Price</div>
                                                                                              <div>{{itemControl.controls['cost'].value | currency:'GBP'}}</div>
                                                                                            </div>
                                                                                            <div>
                                                                                              <div class="mb-1">Lead Time</div>
                                                                                              <div>{{itemControl.controls['leadTime'].value}}</div>
                                                                                            </div>
                                                                                            <div>
                                                                                              <div class="mb-1">Total Price</div>
                                                                                              <div class="text-primary">{{itemControl.controls['cost'].value * itemControl.controls['quantity'].value | currency:'GBP'}}</div>
                                                                                            </div>
                                                                                          </div>
                                                                                        </div>
                                                                                      </ng-container> -->
                                </ng-container>
                                }
                            </form>
                            }
                        </div>

                        @if (summaryForm?.controls['paymentTerm'].value) {
                        <div class="mx-4 p-3 bg-gray-100">
                            Payment Terms: {{ summaryForm.controls['paymentTerm'].value }}
                        </div>
                        }

                        @if (summaryForm) {
                        <div class="flex justify-end mx-4">
                            <div class="divide-y py-4 px-6 flex flex-col">
                                <div
                                    class="flex justify-between py-2 text-lg gap-18"
                                >
                                    <div>Subtotal:</div>
                                    <div>
                                        {{
                                            getTotalPrice() *
                                                getMarginModifier()
                                                | currency: "GBP"
                                        }}
                                    </div>
                                </div>
                                <div
                                    class="flex justify-between py-2 text-lg gap-18"
                                >
                                    <div>Freight:</div>
                                    <div>
                                        {{
                                            summaryForm.controls["freightCost"]
                                                .value | currency: "GBP"
                                        }}
                                    </div>
                                </div>
                                <div
                                    class="flex justify-between py-2 text-lg gap-18"
                                >
                                    <div>
                                        VAT ({{
                                            summaryForm.controls["vatRate"]
                                                .value * 100
                                        }}%):
                                    </div>
                                    <div>
                                        {{
                                            getTotalPrice() *
                                                getMarginModifier() *
                                                summaryForm.controls["vatRate"]
                                                    .value | currency: "GBP"
                                        }}
                                    </div>
                                </div>
                                <div
                                    class="flex justify-between py-2 text-2xl gap-18"
                                >
                                    <div>Total (inc VAT):</div>
                                    <div class="text-primary">
                                        {{
                                            getTotalPrice() *
                                                getMarginModifier() *
                                                (1 +
                                                    summaryForm.controls[
                                                        "vatRate"
                                                    ].value) +
                                                summaryForm.controls[
                                                    "freightCost"
                                                ].value | currency: "GBP"
                                        }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        }

                        <div class="border-b"></div>

                        <div class="flex flex-col gap-4 mx-4">
                            @if (customerForm?.controls['notes']?.value) {
                            <div class="uppercase">Notes</div>
                            <div class="whitespace-pre-line">
                                {{ customerForm.controls['notes'].value }}
                            </div>
                            }

                            <div class="p-6 bg-gray-50 mt-4">
                                <div>
                                    Please note this quotation is valid for 30
                                    days from the date issued. After this period
                                    pricing, availability and lead times may be
                                    subject to change.
                                </div>
                            </div>
                        </div>

                        <footer>
                            <img
                                src="assets/dlm-images/dlm/dlm-footer-landscape.png"
                            />
                        </footer>
                    </div>

                    <div class="flex flex-col gap-2">
                        @if (hasZeroCostLines()) {
                        <p class="text-red-600 text-sm text-right">
                            {{ getZeroCostLineCount() }} line(s) have £0 cost.
                            Set a price on each before sending.
                        </p>
                        }
                        <div class="flex justify-between gap-4">
                            <button
                                mat-stroked-button
                                matStepperPrevious
                                type="button"
                            >
                                Back
                            </button>
                            @if (!dealId || deal?.isWizardInProgress) {
                            <button
                                class="ml-auto"
                                (click)="save(true, true)"
                                mat-stroked-button
                                type="button"
                            >
                                Save Progress
                            </button>
                            }
                            <button
                                [class.ml-auto]="
                                    !(!dealId || deal?.isWizardInProgress)
                                "
                                mat-flat-button
                                (click)="downloadPdf()"
                                type="button"
                                [color]="'primary'"
                            >
                                Download
                            </button>
                            <!-- Send Quote is always available (incl. edit-BOM mode), so a
                                 Negotiation quote can still be sent to the client without
                                 being forced to create a revision. -->
                            <button
                                mat-flat-button
                                (click)="save(false, true)"
                                type="button"
                                [color]="'primary'"
                                [disabled]="hasZeroCostLines()"
                            >
                                Send Quote
                            </button>
                        </div>
                    </div>
                </div>
            </mat-step>
        </mat-horizontal-stepper>
    </div>

    <!-- Divider -->
    <!-- <div class="my-6 border-t"></div> -->

    <!-- Actions -->
    <!-- <div class="flex flex-row items-between w-full gap-4">
                                                                  <div class="flex items-center justify-end ml-auto gap-4">
                                                                    <button
                                                                      (click)="close()"
                                                                      mat-stroked-button
                                                                      type="button">
                                                                      Cancel
                                                                    </button>

                                                                    <button
                                                                      (click)="save()"
                                                                      mat-flat-button
                                                                      type="button"
                                                                      [color]="'primary'"
                                                                      [disabled]="!form?.valid">
                                                                      <mat-icon class="icon-size-4 mr-1" svgIcon="feather:send"></mat-icon>
                                                                      <span class="ml-1">Submit RMA Request</span>
                                                                    </button>
                                                                  </div>
                                                                </div> -->
</div>

<!-- Print stuff -->
<!-- Header/footer drawn by drawStandardHeaderAndFooter() — no markup needed. -->
